import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { VentaService } from '../../services/venta.service';
import { Carrito } from '../../models/carrito.model';
import { Entrada } from '../../models/entrada.model';
import { NumpadService } from '../../../../shared/services/numpad.service';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { Router, NavigationEnd } from '@angular/router';
import { OpcionesImpresionQR, PagoService } from '../../services/pago.service';
import moment from 'moment';
import * as xml2js from 'xml2js';
import 'moment/min/locales';
import { StepperNavigationService } from '../../services/stepper-navigation.service';
import { ConfigurationService } from 'src/app/core/conf/configuration.service';
import { FormControlService } from 'src/app/shared/services/form-control.service';

import { PrintService } from 'src/app/shared/services/print.service';
import {
  flatMap,
  map,
  concatMap,
  take,
  catchError,
  first,
  switchMap,
  takeWhile,
  tap,
} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AlbaranService } from 'src/app/modules/gestionar-venta/services/albaran.service';
import { EntradasService } from '../../services/entradas.service';
import { MotivosService } from '../../services/motivos.service';
import { ToastrService } from 'ngx-toastr';
import { SidebarNavigationService } from 'src/app/shared/services/sidebar-navigation.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ButacasService } from 'src/app/modules/auditorio/services/butacas.service';
import { entradaToButaca } from 'src/app/modules/auditorio/components/seleccion-butacas/butacaToEntrada.mapper';
import { CardPaymentFactory } from 'src/app/core/hardware/card-payment/cardPayment.factory';
import { CardPaymentType } from 'src/app/core/hardware/card-payment/cardPaymentType.enum';
import { VisorService } from 'src/app/shared/services/visor.service';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { InfoToast } from 'src/app/core/toast/info.toast';
import { Subscription, of, throwError, EMPTY } from 'rxjs';
import { AppConfiguration } from 'src/app/app.configuration';
import { FacturaService } from 'src/app/shared/services/factura.service';
import { LocalizadorService } from 'src/app/modules/localizador/services/localizador.service';
import { ProcedenciaService } from '../../services/procedencia.service';
import {
  extractErrorCode,
  extractErrorMessage,
} from 'src/app/utils/error-handler/xml-parser';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { pais } from '../../models/procedencias.model';
import { SuccessToast } from 'src/app/core/toast/success.toast';
import { DialogMail } from 'src/app/modules/venta/dialog-mail/dialog-mail.component';
import { TurnoService } from 'src/app/core';
import {
  DialogSalePauseComponent,
  DialogSalePauseResult,
} from '../../dialogs/dialog-sale-pause/dialog-sale-pause.component';
import {
  CreateVentaPausadaPOST,
  ListadoProducto,
} from 'src/app/modules/gestionar-pausadas/interfaces/gestionar-pausadas.interface';
import { ListadoMotivo } from '../../../gestionar-pausadas/interfaces/gestionar-pausadas.interface';
import { ListaMotivo } from 'src/app/modules/gestionar-pausadas/models/reserva.model';
import { VentaPausadaService } from 'src/app/modules/gestionar-pausadas/services/venta-pausada.service';
import { DevolucionService } from 'src/app/modules/gestionar-venta/services/devolucion.service';
import { PinPandResponse } from '../../models/pago.model';
import { SinpeService } from 'src/app/shared/services/sinpe.service';
import { SinpeVinculacionResponse } from 'src/app/modules/tienda/models/entrada.microservicio.model';
import { AmigosThyssenService } from 'src/app/modules/amigos-thyssen/services/amigos-thyssen.service';
import { GestorEfectivoService } from 'src/app/core/hardware/gestor-efectivo/gestorEfectivo.service';
import { WayletService } from '../../services/waylet.service';
import {
  normalizeCashKeeperError,
  CASHKEEPER_ERROR_DEFAULT,
  getErrorMessage,
  extractDescriptionCashKeeper,
} from 'src/app/core/hardware/gestor-efectivo/cashkeeper-codigos';

interface DatosAlbaranPagoTarjeta {
  Identificador: string;
  NumAlbaran: string;
  TpvId: string;
}

interface DatosPagoVisa {
  DDFName?: string;
  ReciboSoloCliente?: string;
  caducidad?: string;
  codigoRespuesta?: string;
  comercio?: string;
  conttrans?: string;
  estado?: string;
  etiquetaApp?: string;
  factura?: string;
  fechaOperacion?: string;
  firma?: string;
  idapp?: string;
  identificadorRTS?: string;
  importe?: string;
  marcaTarjeta?: string;
  moneda?: string;
  operContactless?: string;
  operacionemv?: string;
  pedido?: string;
  resultado?: string;
  resverificacion?: string;
  sectarjeta?: string;
  tarjetaClienteRecibo?: string;
  tarjetaComercioRecibo?: string;
  terminal?: string;
  tipoPago?: string;
  tipoTasaAplicada?: string;
  pedidoBase?: string;
  textoReservadoControlador?: string;
  numOperacion?: string;
  tipoOperacion?: string;
  codigoAceptacion?: string;
}

@Component({
  selector: 'ticketing-resumen-compra',
  templateUrl: './resumen-compra.component.html',
  styleUrls: ['./resumen-compra.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    class: 'col-resumen',
  },
})
export class ResumenCompraComponent implements OnInit, OnDestroy {
  config = PERFECT_SCROLLBAR_CONFIG;
  carrito: Carrito;
  ventanaActualDePago;
  ventaActualNoEntradas;
  sePuede = true;
  idioma = 'es-ES';
  paseHorarioSeleccion = 'SIN SELECCIÓN DE PASE HORARIO';
  divisaSimbSeparacionMiles: string;
  divisaSimboloDecimal: string;
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  esGranDivisa: boolean;
  divisaSimboloDerecha: string;
  estaPagando = false;
  routerSub: Subscription;
  carritoSub: Subscription;
  datosInicioSub: Subscription;
  marcarDesmarcarSub: Subscription;
  pagarTarjetaSub: Subscription;
  pagarSub: Subscription;
  cabeceraSub: Subscription;
  carritoOrigen: Carrito;
  carritoOrigenSub: Subscription;
  hayDescuento = true;
  hayDescuentoSub: Subscription;
  validarTarjetaMonederoSub: Subscription;
  reImprimirTicketsSub: Subscription;
  imprimiendoTickets: boolean = false;
  disabledEntrar = false;
  waitingMessageKey = 'IMPRIMIENDOTICKETS';
  mails: string;
  listadoPaises: any[];
  private alive = true;
  ticketsProductosArr: any[];
  @Input() masEntradas;
  arr = [];
  selectedItems = [];
  tpvParametro: string;

  appConfigValue = null;
  ventaPausadaSub: Subscription;

  ventanaHoras: boolean;
  ventanaLocalizador: boolean;
  ventanaGestionar: boolean;

  desmarcarSub: Subscription;


  constructor(
    public ventaService: VentaService,
    private numpadService: NumpadService,
    private pagoService: PagoService,
    private stepper: StepperNavigationService,
    private albaranService: AlbaranService,
    private configuration: ConfigurationService,
    private formControlService: FormControlService,
    public router: Router,
    private stepperNavigation: StepperNavigationService,
    private sidebarNavigation: SidebarNavigationService,
    private modalService: ModalService,
    private printService: PrintService,
    private entradaService: EntradasService,
    private motivosService: MotivosService,
    private toast: ToastrService,
    private butacaService: ButacasService,
    private visor: VisorService,
    private facturaService: FacturaService,
    private configuracion: AppConfiguration,
    private localizadorService: LocalizadorService,
    private procedenciaService: ProcedenciaService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private turnoService: TurnoService,
    public dialog: MatDialog,
    private ventaPausadaService: VentaPausadaService,
    private devolucionService: DevolucionService,
    private sinpeService: SinpeService,
    private amigosThyssenService: AmigosThyssenService,
    private gestorEfectivoService: GestorEfectivoService,
    private wayletService: WayletService,
    private cdr: ChangeDetectorRef
  ) {
    this.routerSub = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const segments = val.url.split('/').filter(Boolean);
        this.ventanaActualDePago = segments.includes('pago');
        /*         this.ventanaActualDePago =
          val.url.split('/')[2] === 'horarios' ? false : true; */
        this.ventaActualNoEntradas =
          val.url.split('/')[2] === 'entradas' ? false : true;

        this.ventanaHoras = val.url.split('/')[2] === 'horarios' ? true : false;

        this.ventanaLocalizador =
          val.url.split('/')[1] === 'localizador' ? true : false;

        this.ventanaGestionar =
          val.url.split('/')[1] === 'gestionar-venta' && val.url.split('/')[2]
            ? true
            : false;
      }
    });

    this.appConfigValue = this.configuration.getAppConfigValue();
  }

  ngOnInit() {
    this.divisaSimbSeparacionMiles =
      this.configuration.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal =
      this.configuration.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configuration.divisasValue[0].simbolo;
    this.divisaDecimales = Number(
      this.configuration.divisasValue[0].NumeroDecimales
    );
    this.divisaPosicion = this.configuration.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha =
      this.configuration.divisasValue[0].SimboloDerecha;

    this.carritoSub = this.ventaService.carrito.subscribe((carrito) => {
      this.carrito = carrito;
    });
    this.carritoOrigenSub = this.ventaService.carritoOrigen.subscribe(
      (carrito2) => {
        this.carritoOrigen = carrito2;
      }
    );
    this.datosInicioSub = this.configuration.datosInicio.subscribe((conf) => {
      this.idioma = conf.Idioma;
    });
    this.hayDescuentoSub = this.ventaService.hayDescuento$.subscribe((desc) => {
      this.hayDescuento = desc;
    });
    this.facturaService
      .getPaises()
      .pipe(takeWhile(() => this.alive))
      .subscribe((res: any) => {
        // ;
        if (res.DatosPaises) {
          // seleccionable
          this.listadoPaises = res.DatosPaises;
          //
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    if (this.carritoSub) {
      this.carritoSub.unsubscribe();
    }
    if (this.datosInicioSub) {
      this.datosInicioSub.unsubscribe();
    }
    if (this.marcarDesmarcarSub) {
      this.marcarDesmarcarSub.unsubscribe();
    }
    if (this.carritoOrigenSub) {
      this.carritoOrigenSub.unsubscribe();
    }
    if (this.hayDescuentoSub) {
      this.hayDescuentoSub.unsubscribe();
    }
    if (this.validarTarjetaMonederoSub) {
      this.validarTarjetaMonederoSub.unsubscribe();
    }
    if (this.reImprimirTicketsSub) {
      this.reImprimirTicketsSub.unsubscribe();
    }

    if (this.ventaPausadaSub) {
      this.ventaPausadaSub.unsubscribe();
    }

    // if (this.pagarTarjetaSub) {
    //   this.pagarTarjetaSub.unsubscribe();
    // }
    //  if (this.pagarSub) {
    //   this.pagarSub.unsubscribe();
    // }
    // if (this.cabeceraSub) {
    //   this.cabeceraSub.unsubscribe();
    // }
  }

  openDialog(): void {
    this.pagoService.setNoMailValue(false);
    const dialogRef = this.dialog.open(DialogMail, {
      data: { mails: this.mails },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.mails = result;
      if (
        this.mails ||
        (this.pagoService.noMailValue && this.pagoService.sendMailValue)
      ) {
        this.disabledEntrar = true;
        this.pagoService.setStringMailValue(this.mails);
        if (this.esPagoConTarjeta()) {
          this.pagarConTarjeta();
          return;
        }
        this.ejecutarCashKeeperAntesDeVenta().then((ok) => {
          if (ok) {
            this.llamarPeticionDePago();
          }
        });
      }
    });
  }

  redondearPrecios(precio) {
    return Math.round(precio * 100) / 100;
  }

  eliminarLinea(linea: { entrada: any; cantidad: number }) {
    const indiceEntradaEliminada = this.carrito && this.carrito.entradas
      ? this.carrito.entradas.findIndex((item) => item && item.entrada === linea.entrada)
      : -1;
    if (linea.entrada.noEditable) {
      return;
    }
    if (this.ventanaActualDePago) {
      return;
    }

    console.log('linea:: ', linea);
    // Promoción/entradas con motivos: la «X» del resumen debe borrar la línea (CP-10). Editar motivos: clickToOpenMotivosModal / foco en cantidad.

    // if (linea.entrada.TipoProducto == '2') {
    //   let motivoId = 0;
    //   let tipoEntradaId; // Yaribel 20201229  Añadimos variable para capturar tipo de entrada
    //   linea.entrada.PromocionEntradas.forEach(element => {
    //     if (element.GrupoMotivoId && Number.parseInt(element.GrupoMotivoId , 10) > 0) {
    //       motivoId = element.GrupoMotivoId;
    //       tipoEntradaId = element.TipoEntradaId; // Yaribel 20201229  Añadimos variable para capturar tipo de entrada
    //     }
    //   });
    //   if (motivoId > 0) {
    //     this.entradaService.setEntradaSeleccionada(linea.entrada);
    //     //<< Yaribel 20201229  controlamos la llamada al modal solo si los motivos son seleccionables
    //   this.entradaService.comprobarGrupoMotivoDescuentoSeleccionable(tipoEntradaId).subscribe(motivoSeleccionable =>{
    //     if(motivoSeleccionable)
    //     {
    //       this.modalService.open('selector-motivos');
    //       return;
    //     }
    //   });
    //   // Yaribel 20201229  controlamos la llamada al modal solo si los motivos son seleccionables        >>
    //   }
    // }  else if (linea.entrada.GrupoMotivoId && Number.parseInt(linea.entrada.GrupoMotivoId , 10) > 0) {
    //   this.entradaService.setEntradaSeleccionada(linea.entrada);
    //   //<< Yaribel 20201229  controlamos la llamada al modal solo si los motivos son seleccionables
    //   this.entradaService.comprobarGrupoMotivoDescuentoSeleccionable(linea.entrada.TipoEntradaId).subscribe(motivoSeleccionable =>{
    //     if(motivoSeleccionable)
    //     {
    //       this.modalService.open('selector-motivos');
    //       return;
    //     }
    //   });
    //   // Yaribel 20201229  controlamos la llamada al modal solo si los motivos son seleccionables        >>
    // }

    // Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables >>
    const url = this.stepperNavigation.getCurrentPasoUrl();

    // 1 unidad por «X»; clon con Cantidad 1 evita que entrada.Cantidad del UI borre toda la línea de golpe.
    const entradaUnidad = { ...(linea.entrada as any), Cantidad: 1 } as Entrada;
    this.carrito.eliminarEntrada(entradaUnidad);

    const idTarifaLinea = linea.entrada?.idTarifa;
    const entradaEnCarritoTrasBorrado =
      idTarifaLinea != null && idTarifaLinea !== ''
        ? (this.carrito.entradas || []).find(
            (e) => e?.entrada && String(e.entrada.idTarifa) === String(idTarifaLinea)
          )
        : null;
    if (!(this.carrito?.entradas?.length)) {
      this.motivosService.setMotivosSeleccionados([]);
      this.entradaService.setEntradaSeleccionada(undefined);
    } else if (idTarifaLinea != null && idTarifaLinea !== '') {
      if (!entradaEnCarritoTrasBorrado) {
        this.motivosService.removeMotivosParaEntrada(idTarifaLinea);
        const sel = this.entradaService.entradaSeleccionada;
        if (sel && String(sel.idTarifa) === String(idTarifaLinea)) {
          this.entradaService.setEntradaSeleccionada(undefined);
        }
      } else {
        this.motivosService.ajustarMotivosTrasEliminarParcial(
          idTarifaLinea,
          entradaEnCarritoTrasBorrado.cantidad,
          entradaEnCarritoTrasBorrado.entrada
        );
      }
    }

    // Eliminamos los horarios de pasos si ningun entrada no tiene
    if (
      !this.carrito.entradas.length ||
      this.carrito.entradas.every((e) => e.entrada.recintos.length === 0)
    ) {
      this.stepperNavigation.eliminarHorarioDePasos();
      this.stepperNavigation.getUrlVentaSlice();
    }
    // const pasos = this.stepperNavigation.pasos;
    // const isPasoDeAuditorio = pasos[0].url === 'actividades';
    // const horarioNoExist = pasos.findIndex(paso => paso.url === 'horarios')
    // horarioNoExist !== -1 && isPasoDeAuditorio && pasos.splice(horarioNoExist, 1);

    // this.stepperNavigation.pasos = pasos;

    this.carrito.recalcularTotales();
    this.ventaService.setCarrito(this.carrito);
    if (indiceEntradaEliminada > -1 && this.ventaService?.carritoValue?.horarios?.length) {
      this.ventaService.carritoValue.horarios = this.ventaService.carritoValue.horarios.map((horario) => {
        const idxH = horario?.indiceEntrada;
        const idxHNum = idxH === undefined || idxH === null || idxH === '' ? NaN : Number(idxH);
        if (horario && Number.isFinite(idxHNum) && idxHNum > indiceEntradaEliminada) {
          return { ...horario, indiceEntrada: idxHNum - 1 };
        }
        return horario;
      });
    }
    if (!linea.entrada.auditorio) {
      const lineaUnidad = { ...linea, cantidad: 1 };
      const input = document.getElementById(
        // `linea-${this.masEntradas}${this.numpadService.entrada.idTarifa}`
        `linea-${this.ventaService.masEntradasValue}${this.numpadService.entrada.idTarifa}`
      );
      if (this.ventaService.carritoValue.horarios.length > 0) {
        const indicesEliminar = [];
        const recintosEliminar = [];

        linea.entrada.recintos.forEach((r) => recintosEliminar.push(r.Recinto));
        const horariosArr = this.ventaService.carritoValue.horarios;
        const idTfLinea = String(linea?.entrada?.idTarifa ?? '');
        const horarioTieneProductoLinea = (item: any) => {
          const cxe = item?.cantidadxentrada || [];
          if (!cxe.length) {
            return true;
          }
          return cxe.some((ce: any) => String(ce?.entrada?.idTarifa ?? '') === idTfLinea);
        };
        const horarioPerteneceALineaEliminada = (item: any) => {
          if (!item?.recinto || !recintosEliminar.includes(item.recinto.Recinto)) {
            return false;
          }
          if (indiceEntradaEliminada < 0) {
            return true;
          }
          // indiceEntrada puede venir como string desde API/JSON; si no es numérico coherente,
          // NO hacer match amplio (antes: return true) o se resta en TODOS los horarios del recinto y desincroniza cabeceras vs carrito.
          const idxH = item?.indiceEntrada;
          const idxHNum = idxH === undefined || idxH === null || idxH === '' ? NaN : Number(idxH);
          if (Number.isFinite(idxHNum)) {
            return idxHNum === indiceEntradaEliminada && horarioTieneProductoLinea(item);
          }
          return false;
        };
        let indicesProcesar = horariosArr
          .map((item, i) => (horarioPerteneceALineaEliminada(item) ? i : -1))
          .filter((i) => i >= 0);
        if (indicesProcesar.length === 0 && indiceEntradaEliminada >= 0) {
          const candidatosIdx = horariosArr
            .map((item, i) => ({ item, i }))
            .filter(
              ({ item }) =>
                item?.recinto &&
                recintosEliminar.includes(item.recinto.Recinto) &&
                horarioTieneProductoLinea(item)
            )
            .map(({ i }) => i);
          if (candidatosIdx.length > 0) {
            const pick =
              indiceEntradaEliminada < candidatosIdx.length
                ? candidatosIdx[indiceEntradaEliminada]
                : candidatosIdx[candidatosIdx.length - 1];
            indicesProcesar = [pick];
          }
        }
        //
        horariosArr.forEach((item, index) => {
          //
          if (indicesProcesar.includes(index)) {
            const sesionId = item && item.sesion ? item.sesion.RecintosSesionId : null;
            let aforoCancelado = false;
            if (sesionId) {
              this.ventaService.eliminarAforoSesion(sesionId).subscribe(() => {});
              aforoCancelado = true;
            }
            //
            //
            if (item.cantidadxentrada && item.cantidadxentrada.length > 0) {
              // eliminarEntrada ya restó en carrito; cantidadxentrada comparte referencias → no reducir de nuevo.
              this.ventaService.sincronizarCxeHorarioConCarrito(item, idTfLinea);
              item.cantidad = this.calcularCantidadTotalHorario(item.cantidadxentrada);
              if (
                !linea.entrada.Caracteristicas ||
                linea.entrada.Caracteristicas.NumPeriodos == ''
              ) {
                if (item.cantidad > 0) {
                  item.resumen = `${item.recinto.NombreRecinto} - ${moment(
                    item.recinto.fecha,
                    'YYYY/MM/DD'
                  )
                    .locale(this.idioma)
                    .format('L')} ${item.sesion.HoraInicio} (${item.cantidad})`;
                  // this.ventaService
                  // .reservaAforo(item.sesion.RecintosSesionId, item.cantidad, linea.entrada.TipoEntradaId)
                  // .subscribe();
                  this.ventaService
                    .reservaAforoProductos(
                      this.mapeaListaentradas2ListaProductos(item.cantidadxentrada),
                      item.recinto.Recinto,
                      this.fechaYYYYMMDD2slash(
                        item.sesion.Fecha,
                        item.sesion.HoraInicio
                      )
                    )
                    .subscribe();
                } else {
                  if (!aforoCancelado && item.sesion.RecintosSesionId) {
                    this.ventaService
                      .eliminarAforoSesion(item.sesion.RecintosSesionId)
                      .subscribe((data) => {});
                  }
                  indicesEliminar.push(index);
                }
              } else {
                if (item.cantidadxentrada.length > 0) {
                  //for (const entradaR of item.cantidadxentrada) {
                  //if (entradaR.entrada.TipoEntradaId ==  linea.entrada.TipoEntradaId) {
                  this.ventaService
                    //.reservaAforo(item.sesion.RecintosSesionId, item.cantidad - linea.cantidad, linea.entrada.TipoEntradaId)
                    .reservaAforoProductos(
                      this.mapeaListaentradas2ListaProductos(item.cantidadxentrada),
                      item.recinto.Recinto,
                      this.fechaYYYYMMDD2slash(
                        item.sesion.Fecha,
                        item.sesion.HoraInicio
                      )
                    )
                    .subscribe();
                  //}
                  //}
                }
                if (!item.cantidadxentrada.length || item.cantidad <= 0) {
                  if (!aforoCancelado && item.sesion.RecintosSesionId) {
                    this.ventaService
                      .eliminarAforoSesion(item.sesion.RecintosSesionId)
                      .subscribe((data) => {});
                  }
                  indicesEliminar.push(index);
                }
              }
            } else {
              const listaParaReserva = this.obtenerListaEntradasHorarioVigente(item);
              const cantidadTotal = this.calcularCantidadTotalHorario(listaParaReserva);
              if (cantidadTotal > 0) {
                item.cantidad = cantidadTotal;
                item.resumen = `${item.recinto.NombreRecinto} - ${moment(
                  item.recinto.fecha,
                  'YYYY/MM/DD'
                )
                  .locale(this.idioma)
                  .format('L')} ${item.sesion.HoraInicio} (${item.cantidad})`;
                const listadoProductosCalculado =
                  this.mapeaListaentradas2ListaProductos(listaParaReserva);
                this.ventaService
                  .reservaAforoProductos(
                    listadoProductosCalculado,
                    item.recinto.Recinto,
                    this.fechaYYYYMMDD2slash(
                      item.sesion.Fecha,
                      item.sesion.HoraInicio
                    )
                  )
                  .subscribe();
                // Yaribel 20210112 >>
              } else {
                if (!aforoCancelado && item.sesion.RecintosSesionId) {
                  this.ventaService
                    .eliminarAforoSesion(item.sesion.RecintosSesionId)
                    .subscribe((data) => {});
                }
                indicesEliminar.push(index);
              }
            }
            if (item.cantidad > 0) {
              item.resumen = `${item.recinto.NombreRecinto} - ${moment(
                item.recinto.fecha,
                'YYYY/MM/DD'
              )
                .locale(this.idioma)
                .format('L')} ${item.sesion.HoraInicio} (${item.cantidad})`;
            }
          }
        });
        if (indicesEliminar.length > 0) {
          const indicesOrdenados = Array.from(new Set(indicesEliminar)).sort((a, b) => b - a);
          indicesOrdenados.forEach((indice) => {
            this.ventaService.carritoValue.horarios.splice(indice, 1);
          });
          //
        }
      }
      const totalEntradasCarrito = this.carrito?.entradas?.length || 0;
      if (totalEntradasCarrito === 0) {
        // Si ya no hay entradas, se limpian los horarios remanentes.
        this.ventaService.carritoValue.horarios = [];
      }
      const oldVals = {
        selected: this.numpadService.selected,
        entrada: this.numpadService.entrada,
        input: document.getElementById(
          // `linea-${this.masEntradas}${this.numpadService.entrada.idTarifa}`
          `linea-${this.ventaService.masEntradasValue}${this.numpadService.entrada.idTarifa}`
        ),
      };
      this.numpadService.selected = input;
      this.numpadService.entrada = linea.entrada;
      this.formControlService.setCurrentFormGroup(
        null,
        input,
        input ? input.getAttribute('category') : ''
      );
      if (!input) {
        this.formControlService.setToBlank();
      }
      this.numpadService.selected = oldVals.selected;
      this.numpadService.entrada = oldVals.entrada;
      this.formControlService.setCurrentFormGroup(
        null,
        oldVals.input,
        oldVals.input ? oldVals.input.getAttribute('category') : ''
      );
      // this.numpadService.entrada = entradaOriginal;
      if (this.ventaActualNoEntradas) {
        this.resetPasosAndNavigateToParentUrl(url);
      }
      // this.stepper.setNextSteps();
    } else {
      const b = entradaToButaca(linea.entrada);
      if (linea.entrada.extraData.tag === '') {
        this.marcarDesmarcarSub = this.butacaService
          .httpPostMarcarDesmarcarButaca(
            b,
            false,
            linea.entrada.extraData.idRecintoButaca
          )
          .subscribe(() => {
            //
            this.butacaService.removeButaca(b);
            this.resetPasosAndNavigateToParentUrl(url);
          });
      } else {
        this.marcarDesmarcarSub = this.butacaService
          .httpPostMarcarDesmarcarButaca(b, false)
          .subscribe(() => {
            //
            this.butacaService.removeButaca(b);
            this.resetPasosAndNavigateToParentUrl(url);
          });
      }
    }
    const carritoOrigenVal = this.ventaService.carritoOrigenValue;
    const carritoVal = this.ventaService.carritoValue;
    if (carritoOrigenVal && carritoVal) {
      if (Array.isArray(carritoVal.horarios)) {
        carritoOrigenVal.horarios = carritoVal.horarios;
      }
      if (Array.isArray(carritoVal.entradas)) {
        carritoOrigenVal.entradas = carritoVal.entradas;
      }
    }
  }

  private reducirCantidadEntradaEnHorario(cantidadxentrada: any[], linea: { entrada: any; cantidad: number }): any[] {
    const idTarifaLinea = String(linea?.entrada?.idTarifa ?? '');
    const tipoEntradaId = `${linea?.entrada?.TipoEntradaId || ''}`;
    let remaining = Number(linea?.cantidad || 0);
    if (remaining <= 0) {
      return cantidadxentrada || [];
    }
    const arr = cantidadxentrada || [];
    const desgloseUsaTarifa = arr.some((ce) => String(ce?.entrada?.idTarifa ?? '') !== '');
    const filaCoincide = (ce: any) => {
      const ceIdTarifa = String(ce?.entrada?.idTarifa ?? '');
      const tipoEntradaHorario = `${ce?.entrada?.TipoEntradaId || ''}`;
      if (idTarifaLinea !== '') {
        if (ceIdTarifa === idTarifaLinea) {
          return true;
        }
        return !desgloseUsaTarifa && ceIdTarifa === '' && tipoEntradaHorario === tipoEntradaId;
      }
      return tipoEntradaHorario === tipoEntradaId;
    };
    const out = arr
      .map((ce) => {
        if (remaining <= 0 || !filaCoincide(ce)) {
          return ce;
        }
        const q = Number(ce?.cantidad || 0);
        const sub = Math.min(q, remaining);
        remaining -= sub;
        return { ...ce, cantidad: q - sub };
      })
      .filter((ce) => Number(ce?.cantidad || 0) > 0);
    return out;
  }

  private calcularCantidadTotalHorario(cantidadxentrada: any[]): number {
    return (cantidadxentrada || []).reduce((acc, ce) => acc + Number(ce?.cantidad || 0), 0);
  }

  /** cantidasxEntradaSinPeriodo comparte referencias con carrito.entradas; filtra líneas ya eliminadas. */
  private obtenerListaEntradasHorarioVigente(item: any): any[] {
    const lista =
      item?.cantidadxentrada?.length > 0
        ? item.cantidadxentrada
        : item?.cantidasxEntradaSinPeriodo;
    if (!lista?.length) {
      return [];
    }
    const idsCarrito = new Set(
      (this.carrito?.entradas || []).map((e) => String(e?.entrada?.idTarifa ?? ''))
    );
    return lista.filter((ce) => idsCarrito.has(String(ce?.entrada?.idTarifa ?? '')));
  }

  clickToOpenMotivosModal(entrada) {
    if (entrada.noEditable || this.ventanaActualDePago) {
      return;
    }
    if (entrada.noEditable || this.ventaActualNoEntradas) {
      // TODO: modificacion por incidencia

      return;
    }
    if (this.ventaActualNoEntradas) {
      const url = this.stepperNavigation.getCurrentPasoUrl();
      // const url = this.router.url;
      this.resetPasosAndNavigateToParentUrl(url);
    }
    //<< Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables
    if (
      entrada.GrupoMotivoId &&
      Number.parseInt(entrada.GrupoMotivoId, 10) > 0
    ) {
      this.entradaService.setEntradaSeleccionada(entrada);
      this.modalService.open('selector-motivos');
      return;
    }
  }

  focusValue(event: FocusEvent, entrada) {
    if (entrada.noEditable) {
      return;
    }
    if (this.ventaActualNoEntradas) {
      const url = this.stepperNavigation.getCurrentPasoUrl();
      this.resetPasosAndNavigateToParentUrl(url);
    }
    if (
      entrada.GrupoMotivoId &&
      Number.parseInt(entrada.GrupoMotivoId, 10) > 0
    ) {
      this.entradaService.setEntradaSeleccionada(entrada);
      this.modalService.open('selector-motivos');
      return;
    }
    const target = event.target as HTMLInputElement;
    const category = target.getAttribute('category');
    target.value = '';
    this.numpadService.selected = target;
    this.numpadService.entrada = entrada;
    this.formControlService.setCurrentFormGroup(null, target, category);

    this.numpadService.commaDisabled = category === 'CANTIDAD';
  }

  unfocusValue(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.numpadService.setNumpadOrder('reset');
      return;
    }
  }

  /** Blur cantidad en resumen (template): alinear con selector-entradas vía numpad/unfocus. */
  test(event: FocusEvent, _entrada: Entrada): void {
    this.unfocusValue(event);
  }

  resetPasosAndNavigateToParentUrl(url) {
    this.router.navigate([url]);
    this.stepper.resetearPasos();
    this.stepperNavigation.desbloquearNavegacionPorPago();
    this.stepperNavigation.eliminarHorarioDePasos();
    this.stepperNavigation.continuarVenta.next(false);
    this.stepperNavigation.getUrlVentaSlice();
  }

  getMotivosByEntradaId(id) {
    return this.motivosService.getDistinctCountMotivosByEntradaId(id);
  }

  private esPagoConTarjeta(): boolean {
    const pd = this.pagoService.pagoDesglosadoValue || {};
    return (
      Number(pd.pinpad || 0) +
        Number(pd.datafono || 0) +
        Number(pd.waylet || 0) !==
      0
    );
  }

  private esPagoConWaylet(): boolean {
    const pd = this.pagoService.pagoDesglosadoValue || {};
    return Number(pd.waylet || 0) > 0;
  }

  private esPagoConSimpe() {
    return this.sinpeService.getTotalPagar()
      ? Number(this.sinpeService.getTotalPagar()) > 0
      : false;
  }

  private esPagoConPinpad() {
    return this.pagoService.pagoDesglosadoValue.pinpad
      ? Number(this.pagoService.pagoDesglosadoValue.pinpad) > 0
      : false;
  }

  private esPagoConDatafono() {
    return this.pagoService.pagoDesglosadoValue.datafono
      ? Number(this.pagoService.pagoDesglosadoValue.datafono) > 0
      : false;
  }

  /**
   * Ejecuta CashKeeper (venta 'N') antes de confirmar la venta en backend.
   * If cash manager is connected and (cash > 0 or manager active with change), calls processCashOperation.
   * Con gestor activo y efectivo 0 usa el resto por cobrar (p. ej. tarjeta + CashKeeper), no el total.
   * Si falla: anula tarjeta, muestra error y devuelve false. Si OK o no aplica, devuelve true.
   */
  private async ejecutarCashKeeperYContinuarPago(
    datosAlbaran: DatosAlbaranPagoTarjeta
  ): Promise<boolean> {
    const gestorActivo = this.appConfigValue?.AppConfigJsonPago?.GestorEfectivo?.GestorActivo === '1';
    const efectivoNum = Number(this.pagoService.pagoDesglosadoValue?.efectivo) || 0;
    const centimos =
      efectivoNum > 0
        ? Math.round(efectivoNum * 100)
        : gestorActivo
          ? this.pagoService.getRestoEfectivoCentimos()
          : 0;
    if (!this.gestorEfectivoService.isCashManagerConnected() || centimos <= 0) {
      this.pagoService.clearCashKeeperInsercionCambio();
      return true;
    }
    this.pagoService.clearCashKeeperInsercionCambio();
    const res = await this.gestorEfectivoService.processCashOperation('N', centimos);
    if (res.ok) {
      if ('introducedCents' in res) {
        this.pagoService.setCashKeeperInsercionCambioFromGestor(
          res.introducedCents,
          res.returnedCents
        );
      }
      return true;
    }
    try {
      this.albaranService
        .anularAlbaranTarjeta(datosAlbaran.Identificador, datosAlbaran.NumAlbaran)
        .subscribe(
          () => {},
          (err) => {
            console.warn('[ResumenCompra] rollback de tarjeta con error', err);
          }
        );
    } catch (err) {
      console.warn('[ResumenCompra] excepción en rollback de tarjeta', err);
    }
    const rawError = getErrorMessage(res);
    const clave = normalizeCashKeeperError(rawError);
    const traducido = this.translateService.instant(clave);
    const desc = extractDescriptionCashKeeper(rawError);
    const msg =
      traducido === clave
        ? desc || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT)
        : traducido || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT);
    this.toast.error(msg, '', { toastComponent: ErrorToast });
    this.disabledEntrar = false;
    this.estaPagando = false;
    this.cdr.detectChanges();
    return false;
  }

  /**
   * Ejecuta CashKeeper (venta 'N') antes de llamar a llamarPeticionDePago en flujo solo efectivo.
   * Con gestor activo y efectivo 0 usa el resto por cobrar (p. ej. tarjeta + CashKeeper), no el total.
   * Devuelve true si puede continuar, false si CashKeeper falló (ya muestra error).
   */
  private async ejecutarCashKeeperAntesDeVenta(): Promise<boolean> {
    const gestorActivo = this.appConfigValue?.AppConfigJsonPago?.GestorEfectivo?.GestorActivo === '1';
    const efectivoNum = Number(this.pagoService.pagoDesglosadoValue?.efectivo) || 0;
    const centimos =
      efectivoNum > 0
        ? Math.round(efectivoNum * 100)
        : gestorActivo
          ? this.pagoService.getRestoEfectivoCentimos()
          : 0;
    if (!this.gestorEfectivoService.isCashManagerConnected() || centimos <= 0) {
      this.pagoService.clearCashKeeperInsercionCambio();
      return true;
    }
    this.pagoService.clearCashKeeperInsercionCambio();
    const res = await this.gestorEfectivoService.processCashOperation('N', centimos);
    if (res.ok) {
      if ('introducedCents' in res) {
        this.pagoService.setCashKeeperInsercionCambioFromGestor(
          res.introducedCents,
          res.returnedCents
        );
      }
      return true;
    }
    const rawError = getErrorMessage(res);
    const clave = normalizeCashKeeperError(rawError);
    const traducido = this.translateService.instant(clave);
    const desc = extractDescriptionCashKeeper(rawError);
    const msg =
      traducido === clave
        ? desc || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT)
        : traducido || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT);
    this.toast.error(msg, '', { toastComponent: ErrorToast });
    this.disabledEntrar = false;
    this.estaPagando = false;
    this.cdr.detectChanges();
    return false;
  }

  private pagarConTarjeta() {
    let _pago = this.pagoService;
    this.pagarTarjetaSub = this.pagoService
      .generarPedidoTarjeta()
      .subscribe((datosAlbaran: DatosAlbaranPagoTarjeta) => {
        console.log('[Waylet] generarPedidoTarjeta OK', {
          datosAlbaran,
          esPagoConTarjeta: this.esPagoConTarjeta(),
          esPagoConWaylet: this.esPagoConWaylet(),
        });
        if (!datosAlbaran?.Identificador || !datosAlbaran?.TpvId) {
          console.warn('[Waylet] abortado — GenerarNumAlbaranIdentificador sin datos');
          this.disabledEntrar = false;
          this.estaPagando = false;
          return;
        }
        if (this.esPagoConTarjeta()) {
          if (this.esPagoConWaylet()) {
            console.log('[Waylet] iniciando procesarPagoWaylet');
            this.procesarPagoWaylet(datosAlbaran)
              .then((ok) => {
                if (ok) {
                  this.llamarPeticionDePago();
                }
              })
              .catch(() => {
                this.finalizarWayletConError(
                  this.translateService.instant('ERROR_PAGO_WAYLET')
                );
              });
            return;
          }
          //<<Yaribel 20210820 controlamos si el pago es por pinpad que conecte, sino que sea virtual VSTS 8409
          const cardPaymentConnection = CardPaymentFactory.getCardPayment(
            this.pagoService.pagoDesglosadoValue.pinpad != 0
              ? CardPaymentType.PINPAD
              : CardPaymentType.DATAFONO
          );
          // >> VSTS 8409
          const infoTarjeta =
            this.configuration.deviceConfiguration.AppConfigJsonTarjeta;
          try {
            const paymentTipo =
              infoTarjeta.TarjetaTipoComunicacion === 'JCC' ? 'Payment' : 'N';
            const respuestaPagoVisa = cardPaymentConnection.pay(
              this.pad(datosAlbaran.TpvId, 4),
              '2',
              datosAlbaran.NumAlbaran,
              '0',
              datosAlbaran.Identificador,
              paymentTipo,
              infoTarjeta.TarjetaTipoComunicacion,
              //WOIT en pagos multiples debe coger solo el pago con tarjeta
              (
                '' +
                (_pago.pagoDesglosadoValue.pinpad +
                  _pago.pagoDesglosadoValue.datafono)
              ).replace('.', ','),
              //('' + this.ventaService.carritoValue.precioTotal).replace('.', ','),
              '0',
              '',
              '',
              '',
              '',
              '',
              infoTarjeta.TarjetaMCPTerminal,
              infoTarjeta.TarjetaMCPVersion,
              infoTarjeta.TarjetaMCPComercio,
              infoTarjeta.TarjetaMCPClave,
              infoTarjeta.TarjetaMCPPuertoCOM,
              '0'
            );
            const that = this;
            if (infoTarjeta.TarjetaTipoComunicacion === 'JCC') {
              const result =
                respuestaPagoVisa &&
                this.pagoService.parseJCCResponseString(respuestaPagoVisa);
              if (result) {
                if (result.Results[0].ResponseCode === '00') {
                  this.toast.success(
                    this.translateService.instant('JCC_RESPONSE_CODE_00') ||
                      'Approved',
                    '',
                    {
                      toastComponent: SuccessToast,
                      timeOut: 30000,
                    }
                  );

                  const obj: DatosPagoVisa = {
                    importe: result.Results[0].TransactionResponse.FinalAmount,
                    codigoRespuesta:
                      result.Results[0].TransactionResponse.AuthCode,
                    pedido:
                      result.Results[0].TransactionResponse
                        .RRNFinancialAuthorization,
                    numOperacion: result.Results[0].OperationID,
                    caducidad: result.Results[0].TransactionResponse.ExpiryDate,
                    comercio: result.Results[0].TransactionResponse.BatchNo,
                    identificadorRTS:
                      result.Results[0].TransactionResponse.ReceiptNo,
                    terminal: result.Results[0].TransactionResponse.TerminalNo,
                    resultado:
                      result.Results[0].ResponseCode === '00'
                        ? 'OPERACIÓN ACEPTADA'
                        : this.translateService.instant(
                            `JCC_RESPONSE_CODE_${result.Results[0].ResponseCode}`
                          ),
                    tarjetaClienteRecibo:
                      result.Results[0].TransactionResponse.AccountNumber,
                    codigoAceptacion:
                      result.Results[0].ResponseCode === '00' ? 'AC' : 'NP',
                    tipoOperacion: '01',
                    DDFName: undefined,
                    conttrans: undefined,
                    estado: undefined,
                    etiquetaApp: undefined,
                    factura: undefined,
                    fechaOperacion: undefined,
                    idapp: undefined,
                    marcaTarjeta: undefined,
                    moneda: undefined,
                    operContactless: undefined,
                    operacionemv: undefined,
                    resverificacion: undefined,
                    sectarjeta: undefined,
                    tarjetaComercioRecibo: undefined,
                    tipoPago: undefined,
                    tipoTasaAplicada: undefined,
                  };
                  that.pagoService.setOperacionesTarjetaValue(obj);
                  that.ejecutarCashKeeperYContinuarPago(datosAlbaran).then((ok) => {
                    if (ok) {
                      that.pagoService.setPendingCardReversalAfterFailedInsertion(true);
                      that.llamarPeticionDePago();
                    }
                  });
                  return;
                }
              }
            } else {
              const [tipoRespuesta, ...rest] = respuestaPagoVisa.split(':');
              const respuestaXml = rest.join();

              if (tipoRespuesta === 'OK') {
                xml2js.parseString(respuestaXml, function (err, result) {
                  if (err !== null) {
                    that.toast.error(`[${err}`, 'Error', {
                      toastComponent: ErrorToast,
                    });
                    this.disabledEntrar = false;
                    that.estaPagando = false;
                    return;
                  }
                  const obj: DatosPagoVisa = {
                    DDFName: result.Operaciones.resultadoOperacion[0].DDFName
                      ? result.Operaciones.resultadoOperacion[0].tipoPago
                      : undefined,
                    ReciboSoloCliente: result.Operaciones.resultadoOperacion[0]
                      .ReciboSoloCliente
                      ? result.Operaciones.resultadoOperacion[0]
                          .ReciboSoloCliente[0]
                      : undefined,
                    caducidad: result.Operaciones.resultadoOperacion[0]
                      .caducidad
                      ? result.Operaciones.resultadoOperacion[0].caducidad[0]
                      : undefined,
                    codigoRespuesta: result.Operaciones.resultadoOperacion[0]
                      .codigoRespuesta
                      ? result.Operaciones.resultadoOperacion[0]
                          .codigoRespuesta[0]
                      : undefined,
                    comercio: result.Operaciones.resultadoOperacion[0].comercio
                      ? result.Operaciones.resultadoOperacion[0].comercio[0]
                      : undefined,
                    conttrans: result.Operaciones.resultadoOperacion[0]
                      .conttrans
                      ? result.Operaciones.resultadoOperacion[0].conttrans[0]
                      : undefined,
                    estado: result.Operaciones.resultadoOperacion[0].estado
                      ? result.Operaciones.resultadoOperacion[0].estado[0]
                      : undefined,
                    etiquetaApp: result.Operaciones.resultadoOperacion[0]
                      .etiquetaApp
                      ? result.Operaciones.resultadoOperacion[0].etiquetaApp[0]
                      : undefined,
                    factura: result.Operaciones.resultadoOperacion[0].factura
                      ? result.Operaciones.resultadoOperacion[0].factura[0]
                      : undefined,
                    fechaOperacion: result.Operaciones.resultadoOperacion[0]
                      .fechaOperacion
                      ? result.Operaciones.resultadoOperacion[0]
                          .fechaOperacion[0]
                      : undefined,
                    firma: result.Operaciones.resultadoOperacion[0].firma
                      ? result.Operaciones.resultadoOperacion[0].firma
                      : undefined,
                    idapp: result.Operaciones.resultadoOperacion[0].idapp
                      ? result.Operaciones.resultadoOperacion[0].idapp[0]
                      : undefined,
                    identificadorRTS: result.Operaciones.resultadoOperacion[0]
                      .identificadorRTS
                      ? result.Operaciones.resultadoOperacion[0]
                          .identificadorRTS[0]
                      : undefined,
                    importe: result.Operaciones.resultadoOperacion[0].importe
                      ? result.Operaciones.resultadoOperacion[0].importe
                      : undefined,
                    marcaTarjeta: result.Operaciones.resultadoOperacion[0]
                      .marcaTarjeta
                      ? result.Operaciones.resultadoOperacion[0].marcaTarjeta[0]
                      : undefined,
                    moneda: result.Operaciones.resultadoOperacion[0].moneda
                      ? result.Operaciones.resultadoOperacion[0].moneda[0]
                      : undefined,
                    operContactless: result.Operaciones.resultadoOperacion[0]
                      .operContactLess
                      ? result.Operaciones.resultadoOperacion[0]
                          .operContactLess[0]
                      : undefined,
                    operacionemv: result.Operaciones.resultadoOperacion[0]
                      .operacionemv
                      ? result.Operaciones.resultadoOperacion[0].operacionemv[0]
                      : undefined,
                    pedido: result.Operaciones.resultadoOperacion[0].pedido
                      ? result.Operaciones.resultadoOperacion[0].pedido[0]
                      : undefined,
                    resultado: result.Operaciones.resultadoOperacion[0]
                      .resultado
                      ? result.Operaciones.resultadoOperacion[0].resultado[0]
                      : undefined,
                    resverificacion: result.Operaciones.resultadoOperacion[0]
                      .resverificacion
                      ? result.Operaciones.resultadoOperacion[0]
                          .resverificacion[0]
                      : undefined,
                    sectarjeta: result.Operaciones.resultadoOperacion[0]
                      .sectarjeta
                      ? result.Operaciones.resultadoOperacion[0].sectarjeta[0]
                      : undefined,
                    tarjetaClienteRecibo: result.Operaciones
                      .resultadoOperacion[0].tarjetaClienteRecibo
                      ? result.Operaciones.resultadoOperacion[0]
                          .tarjetaClienteRecibo[0]
                      : undefined,
                    tarjetaComercioRecibo: result.Operaciones
                      .resultadoOperacion[0].tarjetaComercioRecibo
                      ? result.Operaciones.resultadoOperacion[0]
                          .tarjetaComercioRecibo[0]
                      : undefined,
                    terminal: result.Operaciones.resultadoOperacion[0].terminal
                      ? result.Operaciones.resultadoOperacion[0].terminal[0]
                      : undefined,
                    tipoPago: result.Operaciones.resultadoOperacion[0].tipoPago
                      ? result.Operaciones.resultadoOperacion[0].tipoPago
                      : undefined,
                    tipoTasaAplicada: result.Operaciones.resultadoOperacion[0]
                      .tipoTasaAplicada
                      ? result.Operaciones.resultadoOperacion[0]
                          .tipoTasaAplicada[0]
                      : undefined,
                  };

                  that.pagoService.setOperacionesTarjetaValue(obj);
                  that.ejecutarCashKeeperYContinuarPago(datosAlbaran).then((ok) => {
                    if (ok) {
                      that.pagoService.setPendingCardReversalAfterFailedInsertion(true);
                      that.llamarPeticionDePago();
                    }
                  });
                });
              }
            }
            const [tipoRespuesta, ...rest] = respuestaPagoVisa.split(':');
            const respuestaXml = rest.join();

            if (tipoRespuesta === 'KO') {
              xml2js.parseString(respuestaXml, (err, result) => {
                if (err) {
                  that.toast.error(`[${err}`, 'Error KO', {
                    toastComponent: ErrorToast,
                    timeOut: 5000,
                  });
                  this.disabledEntrar = false;
                  that.estaPagando = false;
                  return;
                }
                that.toast.error(
                  `[${result.Error[0].codigo[0]}] ${result.Error[0].mensaje[0]}`,
                  'Error',
                  { toastComponent: ErrorToast, timeOut: 5000 }
                );
                this.disabledEntrar = false;
                that.estaPagando = false;
                return;
              });
            }
            if (tipoRespuesta === 'ERR') {
              const errorCodigo = extractErrorCode(respuestaPagoVisa);
              let errorMessage = this.translateService.instant(errorCodigo);
              if (errorCodigo === 'UNKNOWN') {
                errorMessage = extractErrorMessage(respuestaPagoVisa);
              }
              that.toast.error(errorMessage, 'Error ERR', {
                toastComponent: ErrorToast,
                timeOut: 5000,
              });
              this.estaPagando = false;
              this.disabledEntrar = false;
              return;
            }

            this.pagoService.setOtrasFopData([]);
            this.pagoService.setCVaccancePago({
              FOP: '',
              Importe: 0,
              CVaccance: [],
            });
          } catch (e) {
            this.toast.error('Ocurrió un error inesperado', 'Error', {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });
            this.estaPagando = false;
            this.disabledEntrar = false;

            this.pagoService.setOtrasFopData([]);
            this.pagoService.setCVaccancePago({
              FOP: '',
              Importe: 0,
              CVaccance: [],
            });
            return;
          }
        }
        if (this.esPagoConSimpe()) {
          const sinpes = this.sinpeService.getSinpes();
          const sinpesFiltrados = sinpes.map((s) => ({
            CodReferencia: s.codReferencia,
          }));
          this.ventaService
            .vincularPagoSINPE(datosAlbaran.Identificador, sinpesFiltrados)
            .pipe(
              tap((data: SinpeVinculacionResponse) => {
                console.log(data);
                const listadoConImporte = data.listadoSINPE.map(
                  (sinpeRespuesta) => {
                    const original = sinpes.find(
                      (s) => s.codReferencia === sinpeRespuesta.codReferencia
                    );
                    return {
                      ...sinpeRespuesta,
                      importe: original.monto || 0, // por si no se encuentra el original
                    };
                  }
                );

                this.sinpeService.setRespuestaVinculacion(listadoConImporte);
              }),
              catchError((error) => {
                console.error('Error al vincular pago SINPE:', error);
                return throwError(() => error); // Relanzar el error para manejo posterior
              })
            )
            .subscribe(() => this.llamarPeticionDePago());
        }
      });
  }

  pagar() {

    //Mostrar alerta por factura simplificada
    const emiteFacturaSimplificada = this.pagoService.hayQueFacturarSimpleValue;
    const amigoActivo = this.amigosThyssenService.getAmigoActivo();
    const clienteIdInternet = this.configuration.internetConfig?.DatosResult?.ClienteId;
    const clienteSeleccionado = this.ventaService.clienteSeleccionadoValue.Codigo;

    const codigoCliente = amigoActivo
      ? '0' // Forzar 0 cuando viene de AMIGOS THYSSEN
      : this.ventaService.clienteSeleccionadoValue
      ? this.ventaService.clienteSeleccionadoValue.Codigo
      : '0';

    if (emiteFacturaSimplificada && (parseInt(codigoCliente, 10) > 0 && clienteIdInternet != clienteSeleccionado)) {
      this.toastr.info(
        this.translateService.instant('NOFACTURA_CLIENTE_REGISTRADO'),
        '',
        {
          toastComponent: InfoToast,
          timeOut: 15000,
        }
      );
    }

    this.visor.mostrarCambioCompra(this.pagoService.cambioValue);
    this.estaPagando = !this.estaPagando;
    const pd = this.pagoService.pagoDesglosadoValue || {};
    console.log('[Waylet] pagar()', {
      esPagoConTarjeta: this.esPagoConTarjeta(),
      esPagoConWaylet: this.esPagoConWaylet(),
      pagoDesglosado: pd,
      codigoWaylet: this.pagoService.codigoWayletValue,
    });
    if (this.pagoService.sendMailValue) {
      this.openDialog();
    } else {
      this.mails = '';
      this.pagoService.setStringMailValue(this.mails);
      this.disabledEntrar = true;
      if (this.esPagoConTarjeta() || this.esPagoConSimpe()) {
        this.pagarConTarjeta();
        return;
      }
      // CashKeeper (solo efectivo): ejecutar antes de la venta con o sin email
      this.ejecutarCashKeeperAntesDeVenta().then((ok) => {
        if (ok) {
          this.llamarPeticionDePago();
        }
      });
    }
  }

  private getWayletIntervalMs(): number {
    const intervalCfg = Number(
      this.configuration.deviceConfiguration?.AppConfigJsonTarjeta
        ?.TarjetaWayletIntervalo || 5
    );
    return Math.max(1, intervalCfg) * 1000;
  }

  private getWayletTimeoutMs(): number {
    const timeoutCfg = Number(
      this.configuration.deviceConfiguration?.AppConfigJsonTarjeta
        ?.TarjetaWayletTimeOutCallback || 60
    );
    return Math.max(5, timeoutCfg) * 1000;
  }

  private getWayletPasarelaEntorno(): string {
    const entorno = (this.configuracion.getConfig('chEntornoConexion') || 'DESARROLLO').toUpperCase();
    if (entorno.includes('PRE')) {
      return 'WAYLETPREPRODUCCION';
    }
    if (entorno.includes('PRO')) {
      return 'WAYLETPRODUCCION';
    }
    return 'WAYLETDESARROLLO';
  }

  private buildWayletBody(
    paymentId: string,
    wayletPaymentId?: string,
    tipo: 'pago' | 'devolver' | 'cancelar' = 'pago'
  ): any {
    const amount = Math.round(
      Number(this.pagoService.pagoDesglosadoValue.waylet || 0) * 100
    );
    return (
      this.wayletService.buildExternosBody(tipo, {
        paymentId,
        wayletPaymentId,
        qrContent: this.pagoService.codigoWayletValue,
        amountCentimos: tipo === 'cancelar' ? undefined : amount,
      }) || {
        conexionIacpos: JSON.parse(localStorage.getItem('conexionId')),
        EmpresaClave: this.configuracion.getConfig('chClaveEmpresa'),
        ProyectoNombre: this.configuracion.getConfig('chNombreProyecto'),
        PasarelaEntorno: this.getWayletPasarelaEntorno(),
        ObjetoGenerar: {
          paymentId,
          wayletPaymentId: wayletPaymentId || '',
          qrContent: this.pagoService.codigoWayletValue,
          amount,
          items: [],
        },
      }
    );
  }

  private dismissWayletOverlay(): void {
    this.disabledEntrar = false;
    this.estaPagando = false;
    this.waitingMessageKey = 'IMPRIMIENDOTICKETS';
    this.cdr.detectChanges();
  }

  private showWayletToast(type: 'success' | 'error', message: string): void {
    const options = {
      toastComponent: type === 'success' ? SuccessToast : ErrorToast,
      timeOut: type === 'success' ? 5000 : 8000,
      tapToDismiss: true,
      closeButton: true,
    };
    if (type === 'success') {
      this.toast.success(message, '', options);
    } else {
      this.toast.error(message, '', options);
    }
  }

  private finalizarWayletConError(message: string): boolean {
    this.dismissWayletOverlay();
    this.pagoService.clearCodigoWaylet();
    this.showWayletToast('error', message);
    return false;
  }

  private async procesarPagoWaylet(datosAlbaran: DatosAlbaranPagoTarjeta): Promise<boolean> {
    this.waitingMessageKey = 'PROCESANDO_PAGO_WAYLET';
    this.disabledEntrar = true;
    this.estaPagando = true;
    this.cdr.detectChanges();
    const identificador = await this.wayletService
      .generarIdentificadorWaylet({
        tpvId: datosAlbaran.TpvId,
        codigoValidacionUnico: datosAlbaran.Identificador,
      })
      .pipe(take(1))
      .toPromise();
    if (!identificador?.DatosResult?.paymentId) {
      const wayletError =
        identificador?.Mensajes?.[0]?.descripcionMensaje ??
        identificador?.Mensajes?.[0]?.DescripcionMensaje ??
        this.translateService.instant('ERROR_PAGO_WAYLET');
      return this.finalizarWayletConError(wayletError);
    }
    const paymentId = identificador.DatosResult.paymentId;
    const pagoRes = await this.wayletService
      .pagoWaylet(this.buildWayletBody(paymentId))
      .pipe(take(1))
      .toPromise();
    const wayletPaymentId = pagoRes?.DatosResult?.wayletPaymentId;
    if (!wayletPaymentId) {
      const wayletError =
        pagoRes?.Mensajes?.[0]?.descripcionMensaje ??
        pagoRes?.Mensajes?.[0]?.DescripcionMensaje ??
        this.translateService.instant('ERROR_PAGO_WAYLET');
      return this.finalizarWayletConError(wayletError);
    }

    const startAt = Date.now();
    const timeoutMs = this.getWayletTimeoutMs();
    const intervalMs = this.getWayletIntervalMs();
    while (Date.now() - startAt < timeoutMs) {
      const estado = await this.wayletService
        .getRespuestaWaylet({
          paymentId,
          wayletPaymentId,
        })
        .pipe(take(1))
        .toPromise();
      const status = estado?.DatosResult?.status || '';
      if (status === 'PAID') {
        this.pagoService.setOperacionesTarjetaValue({
          esWaylet: true,
          wayletPaymentId,
          paymentId,
          tipoOperacion: '01',
        });
        this.dismissWayletOverlay();
        this.showWayletToast(
          'success',
          this.translateService.instant('PAGO_WAYLET_APROBADO')
        );
        return true;
      }
      if (status === 'REFUSED' || status === 'CANCELED') {
        const msg =
          estado?.DatosResult?.errorDescription ||
          this.translateService.instant('ERROR_PAGO_WAYLET');
        return this.finalizarWayletConError(msg);
      }
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }

    await this.wayletService
      .cancelarPagoWaylet(this.buildWayletBody(paymentId, wayletPaymentId, 'cancelar'))
      .pipe(take(1))
      .toPromise();
    await this.wayletService
      .devolverPagoWaylet(this.buildWayletBody(paymentId, wayletPaymentId, 'devolver'))
      .pipe(take(1))
      .toPromise();
    return this.finalizarWayletConError(
      this.translateService.instant('TIMEOUT_PAGO_WAYLET')
    );
  }

  pausar() {
    this.estaPagando = !this.estaPagando;
    this.openDialogSalePause();
  }

  openDialogSalePause() {
    const dialogRef = this.dialog.open(DialogSalePauseComponent, {
      data: {
        appConfig: this.appConfigValue,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: DialogSalePauseResult) => {
      if (!result.confirm) {
        this.estaPagando = false;
        return;
      }

      console.log({
        result,
      });

      this.llamarPeticionPausarVenta(result.tag);
    });
  }

  getSesionesByEntrada(recintoId, nombreRecinto) {
    const carritoValue = this.ventaService.carritoValue;

    if (!carritoValue.horarios) {
      return [];
    }

    if (carritoValue.horarios.length === 0) {
      return [];
    }

    const horarios = carritoValue.horarios.filter(
      (item) =>
        item.recinto.Recinto === recintoId &&
        item.recinto.NombreRecinto === nombreRecinto
    );

    console.log({
      recintoId,
      nombreRecinto,
      horarios,
      horariosCarrito: carritoValue.horarios,
    });

    if (horarios.length === 0) {
      return [];
    }

    return horarios.map((item) => item.sesion.RecintosSesionId);
  }

  getButacasIdByEntrada(entrada: any) {
    if (!entrada.extraData) {
      return [];
    }

    if (!entrada.extraData.info) {
      return [];
    }

    if (!entrada.extraData.info.infoGeneral) {
      return [];
    }

    const idRecintoButaca = entrada.extraData.info.infoGeneral.recintoButacaId;
    return [idRecintoButaca];
  }

  llamarPeticionPausarVenta(tag: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));

    const claveCentro = localStorage.getItem('claveCentro') || '';

    const carritoValue = this.ventaService.carritoValue;

    if (!carritoValue || carritoValue.entradas.length === 0) {
      this.toastr.error(
        'Error',
        this.translateService.instant('ERROR_CARRITO_VACIO'),
        {
          toastComponent: ErrorToast,
        }
      );
      return;
    }

    let listadoProductos: ListadoProducto[] = [];

    for (const entrada of carritoValue.entradas) {
      const entradaProducto: ListadoProducto = {
        PosicionVenta: 1,
        CodigoPromocional: '',
        Cantidad: entrada.cantidad,
        TarifaId: entrada.entrada.idTarifa,
        CategoriaId: entrada.entrada.CategoriaId
          ? entrada.entrada.CategoriaId
          : 0,
        GrupoTarifaId: entrada.entrada.GrupoTarifa
          ? entrada.entrada.GrupoTarifa
          : 0,
        ListadoSesiones:
          entrada.entrada.recintos.length > 0
            ? this.getSesionesByEntrada(
                entrada.entrada.recintos[0].Recinto,
                entrada.entrada.recintos[0].NombreRecinto
              )
            : [],
        ListadosButacas: entrada.entrada.auditorio
          ? this.getButacasIdByEntrada(entrada.entrada)
          : [],
        ListadoMotivos: [],
      };

      listadoProductos.push(entrada ? entradaProducto : null);
    }

    const body: CreateVentaPausadaPOST = {
      ConexionId: conexionId ? conexionId : '',
      FechaHoraVisita: carritoValue.fecha ? carritoValue.fecha : '',
      Plataforma: 2,
      UsuarioId: this.turnoService.turnoValue.UsuarioId,
      CodigoCliente:
        this.ventaService.currentCliente !== '0'
          ? +this.ventaService.currentCliente
          : 0,
      TPVId: this.turnoService.turnoValue.TpvId
        ? +this.turnoService.turnoValue.TpvId
        : 0,
      ClaveReserva: '',
      FormaPagoId: this.ventaService.clienteSeleccionadoValue
        ? +this.ventaService.clienteSeleccionadoValue.FP_Id
        : 1,
      ValePromocional: '',
      ClaveCentro: claveCentro ? claveCentro : '',
      Estado: 'ENPAUSA',
      Tag: tag ? tag : '',
      AlbaranPausadaId: 0,
      ListadoProductos: listadoProductos,
    };

    console.log({
      action: 'llamarPeticionPausarVenta',
      body: body,
      carrito: carritoValue,
    });

    this.ventaPausadaSub = this.ventaPausadaService
      .createPauseSale(body)
      .subscribe(
        (res: any) => {
          console.log({
            action: 'createPauseSale',
            data: res,
          });

          if (!res || !res.datosResult) {
            const message =
              this.ventaPausadaService.getMessageMicroserviceResult(res);
            this.toastr.error(message, '', {
              toastComponent: ErrorToast,
            });
            return;
          }

          const messages = this.translateService.instant(
            'venta_pausada_messages'
          );
          const message = messages['success'];

          this.toastr.success(message, '', {
            toastComponent: SuccessToast,
          });

          this.reiniciarVenta();

          return;
        },
        (error) => {
          console.log({
            action: 'createPauseSale',
            error: error,
          });

          const message =
            this.ventaPausadaService.getMessageMicroserviceError(error);

          this.toastr.error(message, '', {
            toastComponent: ErrorToast,
          });

          return;
        }
      );
  }

  reiniciarVenta(): void {
    console.log({
      ventanaActualDePago: this.ventanaActualDePago,
      ventanaHoras: this.ventanaHoras,
      ventanaLocalizador: this.ventanaLocalizador,
      ventanaGestionar: this.ventanaGestionar,
      fechaSeleccionadaValue: this.ventaService.fechaSeleccionadaValue,
    });

    if (this.ventanaActualDePago || this.ventanaHoras) {
      //Comprobamos marcarExterno
      let marcarExterno = this.configuracion.getConfig('MARCAR_EXTERNO');
      if (!marcarExterno || marcarExterno == '') marcarExterno = '0';
      if (marcarExterno == '1') {
        this.ventaService.idMarcadoExterno = null;
      }

      this.ventaService.clearCarritoPreservandoAmigosThyssen();
      this.ventaService.setFechaSeleccionadaValue(moment());
      this.sidebarNavigation.unblockVentaAuditorio();
      this.ventaService.carritoModificado = false;
      this.ventaService.setHayDescuento(false); //Yaribel 20210730  cliente Mapfre VSTS 8370
      this.ventaService.currentRecinto = undefined;
      this.stepperNavigation.desbloquearNavegacionPorPago();
      this.pagoService.setPagoTotal(undefined);
      this.pagoService.setCambio(undefined);
      this.pagoService.setDiferencia(undefined);
      this.devolucionService.setPagoTotal(undefined);
      this.devolucionService.setCambio(undefined);
      this.stepperNavigation.continuarVenta.next(false);
      this.stepperNavigation.resetearPasos();
      this.ventaService.carritoSubject
        .pipe(first())
        .subscribe((res1: Carrito) => {
          if (res1.carrito) {
            res1.setCarritoModificacionCarritoValue(res1.carrito);
            this.ventaService.carritoSubject.next(res1);
          }
        });
      if (this.configuracion.getConfig('COMPRAINICIO')) {
        this.ventanaActualDePago = false;
        this.router.navigate([this.configuracion.getConfig('COMPRAINICIO')]);
      } else {
        this.router.navigate(['']);
      }
      return;
    }
    if (this.ventanaLocalizador) {
      this.localizadorService.noSearch = true;
      this.router.navigate(['/localizador']);
      return;
    }
    if (this.ventanaGestionar) {
      this.router.navigate(['/gestionar-venta']);
      return;
    }
    // this.butacaService.httpPostDesamarcarButacasBySesionId().subscribe();
    this.butacaService.removeAllButaca();
    this.ventaService.clearCarritoPreservandoAmigosThyssen();
    // this.ventaService.eliminaReservaAforoCompleto().subscribe();
    this.ventaService.currentRecinto = undefined;
    this.motivosService.setMotivosSeleccionados([]);
    this.ventaService.setFechaSeleccionadaValue(moment());
    this.ventaService.setClienteSeleccionadoValue('');
    this.procedenciaService.setProcedenciasValue(undefined);
    this.ventaService.currentCliente = '0';
    this.formControlService.unfocus();
    this.stepperNavigation.resetearPasos();
    this.stepperNavigation.continuarVenta.next(false);
    if (this.configuracion.getConfig('COMPRAINICIO')) {
      this.router.navigate([this.configuracion.getConfig('COMPRAINICIO')]);
    } else {
      this.router.navigate(['']);
    }
  }

  async anularVenta() {
    this.albaranService.anularDeshabilitado = true;
    let oldNumAlbaran: string = this.albaranService.albaranValue.NumAlbaran;
    const gestorActivo = this.appConfigValue?.AppConfigJsonPago?.GestorEfectivo?.GestorActivo === '1';
    const efectivoNum = Number(this.pagoService.pagoDesglosadoValue?.efectivo) || 0;
    const centimosEfectivo =
      efectivoNum > 0
        ? Math.round(efectivoNum * 100)
        : gestorActivo
          ? this.pagoService.getRestoEfectivoCentimos()
          : 0;
    if (this.gestorEfectivoService.isCashManagerConnected() && centimosEfectivo > 0) {
      const res = await this.gestorEfectivoService.processCashOperation('D', centimosEfectivo);
      if (!res.ok) {
        this.albaranService.anularDeshabilitado = false;
        const rawError = getErrorMessage(res);
        const clave = normalizeCashKeeperError(rawError);
        const traducido = this.translateService.instant(clave);
        const desc = extractDescriptionCashKeeper(rawError);
        const msg =
          traducido === clave
            ? desc || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT)
            : traducido || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT);
        this.toast.error(msg, '', { toastComponent: ErrorToast });
        return;
      }
    }
    if (this.albaranService.albaranValue.TienePagoCC === '1') {
      this.albaranService
        .generarIdentificadores(
          this.albaranService.albaranValue.TPVId,
          this.albaranService.albaranValue.Prefijo
        )
        .subscribe((data: any) => {
          this.albaranService
            .anularAlbaranTarjeta(
              data.DatosResult.Identificador,
              data.DatosResult.NumAlbaran
            )
            .pipe(
              catchError((e) => {
                this.closeModal();
                return of({ success: false, data: null });
              })
            )
            .subscribe((item) => {
              if (item && item.hasOwnProperty('success') && !item.success) {
                return;
              }
              //
              if (item.AlbaranId && item.Facturado === '0') {
                this.llamarPeticionDePago2();
                this.albaranService
                  .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
                  .subscribe(() => {
                    this.albaranService.anulacionTotal.next(false);
                  });
              } else if (item.AlbaranId && item.Facturado === '1') {
                this.llamarPeticionDePago2();
                this.facturaService
                  .pdfFactura(item)
                  .subscribe(async (facturas: any) => {
                    if (facturas.DatosResult) {
                      await this.printService.printFacturaPDF(
                        facturas.DatosResult
                      );
                    }
                  });
              }
              if (item.NumAlbaran) {
                this.imprimirJustificanteDevolucion(item.NumAlbaran, 'TOTAL');
                this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe();
              }
              this.pagoService.setOtrasFopData([]);
              this.pagoService.setCVaccancePago({
                FOP: '',
                Importe: 0,
                CVaccance: [],
              });
            });
        });
    } else {
      const response: any = await this.albaranService.anularAlbaran();
      if (response.AlbaranId && response.Facturado === '0') {
        this.llamarPeticionDePago2();
        this.albaranService
          .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
          .subscribe(() => {
            this.albaranService.anulacionTotal.next(false);
          });
      } else if (response.AlbaranId && response.Facturado === '1') {
        this.llamarPeticionDePago2();
        this.facturaService
          .pdfFactura(response)
          .subscribe(async (facturas: any) => {
            if (facturas.DatosResult) {
              await this.printService.printFacturaPDF(facturas.DatosResult);
            }
          });
      }
      if (response.NumAlbaran) {
        this.imprimirJustificanteDevolucion(response.NumAlbaran, 'TOTAL');
        this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe();
      }
    }
  }

  llamarPeticionDePago2() {

    const entradaConjunta =
      this.pagoService.opcionesPagoValue.controls['entradaConjunta'].value ||
      false;

    this.pagarSub = this.pagoService
      .pagar(entradaConjunta)
      .pipe(
        // Agregar manejo de errores para detener el flujo si falla el pago
        catchError((error) => {
          console.error('Error en el proceso de pago:', error);
          this.estaPagando = false;
          this.disabledEntrar = false;
          this.imprimiendoTickets = false;

          // Reversión TC e inserción: ya gestionados en PagoService.pagar()

          return EMPTY;
        }),
        flatMap((albaran) => {
          // Si se utiliza la opción de tickets
          if (this.pagoService.opcionesPagoValue.controls['tickets'].value) {
            // Si hay más de 20 entradas, se llama a getDatosAlbaranTicketsProductos
            if (albaran.entradas > 10) {
              // Primero, obtener el último albarán
              return this.albaranService
                .getUltimoAlbaran(this.turnoService.turnoValue.TpvId)
                .pipe(
                  switchMap((ultimoAlbaran) => {
                    // Actualizamos el valor del albarán con el último obtenido
                    const numAlbaran =
                      ultimoAlbaran.NumAlbaran || ultimoAlbaran.NumVenta;
                    // Luego, con el número de albarán actualizado, obtenemos los tickets
                    return this.albaranService
                      .getDatosAlbaranTicketsProductos(numAlbaran)
                      .pipe(
                        flatMap((res) => {
                          this.ticketsProductosArr =
                            res.ListadoAlbaranTicketsProductos;
                          this.arr = res.ListadoAlbaranTicketsProductos;
                          const idsSeleccionados = [];
                          this.arr.forEach((item) => {
                            const cadena = item.TicketsGestion.toString();
                            if (cadena.includes(',')) {
                              cadena.split(',').forEach((element) => {
                                const order = Number.parseInt(element, 10);
                                idsSeleccionados.push(order);
                              });
                            } else {
                              const order = Number.parseInt(cadena, 10);
                              idsSeleccionados.push(order);
                            }
                          });

                          const opciones: OpcionesImpresionQR = {
                            itemsReimprimir: idsSeleccionados.join(','), // IDs separados por coma
                          };

                          if (
                            (!this.pagoService.noMailValue &&
                              this.pagoService.sendMailValue) ||
                            !this.pagoService.sendMailValue
                          ) {
                            return this.pagoService
                              .impresionQR20(
                                ultimoAlbaran.NumAlbaran,
                                idsSeleccionados.length,
                                opciones,
                                this.mails
                              )
                              .pipe(
                                map((codigosQR: any) => {
                                  ultimoAlbaran.infoImpresion = codigosQR;
                                  this.disabledEntrar = false;
                                  this.imprimiendoTickets = false;
                                  return ultimoAlbaran;
                                }),
                                catchError((err) => {
                                  // Manejo del error de impresión QR
                                  ultimoAlbaran.infoImpresion = '';
                                  this.disabledEntrar = false;
                                  this.imprimiendoTickets = false;
                                  // this.mostrarError(err, true);
                                  return of(ultimoAlbaran);
                                })
                              );
                          } else {
                            return of(ultimoAlbaran);
                          }
                        })
                      );
                  })
                );
            } else {
              // Para entradas <= 20 se procede con otra opción de impresión QR
              const opciones: OpcionesImpresionQR = {};
              if (
                (!this.pagoService.noMailValue &&
                  this.pagoService.sendMailValue) ||
                !this.pagoService.sendMailValue
              ) {
                return this.pagoService
                  .impresionQR(
                    albaran.NumAlbaran,
                    albaran.entradas,
                    opciones,
                    this.mails
                  )
                  .pipe(
                    map((codigosQR: any) => {
                      albaran.infoImpresion = codigosQR;
                      this.disabledEntrar = false;
                      this.imprimiendoTickets = false;
                      return albaran;
                    }),
                    catchError((err) => {
                      // Manejo del error de impresión QR
                      albaran.infoImpresion = '';
                      this.disabledEntrar = false;
                      this.imprimiendoTickets = false;
                      // this.mostrarError(err, true);
                      return of(albaran);
                    })
                  );
              } else {
                return of(albaran);
              }
            }
          } else {
            return of(albaran);
          }
        }),
        // CashKeeper (venta 'N') se ejecuta antes de confirmar la venta en ejecutarCashKeeperYContinuarPago / ejecutarCashKeeperAntesDeVenta
        // Luego se encadena la impresión de tarjeta y justificante y la actualización del albarán
        concatMap((albaran) => {
          const identificador = albaran.Identificador;
          const identificadorTarjeta = identificador + '_CC';
          // if (this.esPagoConTarjeta()) {
          if (this.esPagoConPinpad()) {
            if (
              (!this.pagoService.noMailValue &&
                this.pagoService.sendMailValue) ||
              !this.pagoService.sendMailValue
            ) {
              this.pagoService
                .impresionTarjeta(identificadorTarjeta, this.mails)
                .toPromise();
            }
          }
          if (this.pagoService.hayQueImprimirAlbaranValue) {
            if (
              (!this.pagoService.noMailValue &&
                this.pagoService.sendMailValue) ||
              !this.pagoService.sendMailValue
            ) {
              // Se ejecuta la impresión del justificante (convertido a promesa)
              this.pagoService
                .impresionJustificante(
                  albaran.NumAlbaran,
                  identificador,
                  {},
                  this.mails
                )
                .toPromise();
            }
          }
          // Se actualiza el albarán con datos adicionales obtenidos
          return this.albaranService
            .getAlbaran(
              this.configuration.datosTPVPathValue.pkId,
              '',
              '',
              albaran.NumAlbaran
            )
            .pipe(
              map((datosAlbaran: any) => {
                albaran.datos = datosAlbaran;
                return albaran;
              })
            );
        })
      )
      .subscribe((res: any) => {
        this.estaPagando = !this.estaPagando;
        this.disabledEntrar = false;
        if (Object.entries(res.datos).length !== 0) {
          // Yaribel 20210311 Cambiamos el orden de apertura de los modales
          if (this.pagoService.hayQueFacturarValue === true) {
            this.modalService.open('facturar');
          }

          if (this.pagoService.hayQueFacturarSimpleValue === true) {
            let cliente = {};
            if (this.ventaService.clienteSeleccionadoValue) {
              if (this.amigosThyssenService.getAmigoActivo()) {
                this.facturaService
                  .crearFacturaSimplificada(cliente, 1)
                  .pipe(first())
                  .subscribe(
                    (res) => {
                      if (res && res.DatosResult) {
                        if (
                          (!this.pagoService.noMailValue &&
                            this.pagoService.sendMailValue) ||
                          !this.pagoService.sendMailValue
                        ) {
                          this.facturaService
                            .impresionFactura(res.DatosResult, this.mails)
                            .subscribe(
                              (response) => {
                                this.albaranService
                                  .refrescarAlbaran(
                                    this.albaranService.albaranValue.NumAlbaran
                                  )
                                  .subscribe();
                              },
                              (error) => {
                                this.albaranService
                                  .refrescarAlbaran(
                                    this.albaranService.albaranValue.NumAlbaran
                                  )
                                  .subscribe();
                              }
                            );
                        } else {
                        }
                      }
                    },
                    (error) => {
                      this.mostrarError(error);
                    }
                  );
              } else {

                const mantenerClienteSeleccionado = this.ventaService.clienteSeleccionadoValue.Codigo;

                this.facturaService
                  .buscarClienteXCodigo(
                    this.ventaService.clienteSeleccionadoValue.Codigo
                  )
                  .pipe(
                    take(1),
                    switchMap((res: any) => {
                      if (
                        res.ResultadoBuscadorClientes &&
                        res.ResultadoBuscadorClientes.length === 1
                      ) {
                        const clienteEncontrado =
                          res.ResultadoBuscadorClientes[0];
  
                        // Obtener ClienteId de la configuración de internet
                        const clienteIdInternet = this.configuration.internetConfig?.DatosResult?.ClienteId;
                        
                        // Validar si puede generar factura simplificada:
                        // CodigoClienteId = "0" OR CodigoClienteId = ClienteId (de TraerDatosInicioInternet)
                        const puedeFacturaSimplificada = 
                          parseInt(clienteEncontrado.Codigo, 10) < 1 || 
                          clienteEncontrado.Codigo === clienteIdInternet;
                        

                        if (puedeFacturaSimplificada) {
                          cliente = {
                            codigoLegal: clienteEncontrado.CIFoDNIFiscal,
                            nombre: clienteEncontrado.NombreClienteFiscal,
                            direccion: clienteEncontrado.DomicilioFiscal,
                            ciudad: clienteEncontrado.LocalidadFiscal,
                            codigoPostal: clienteEncontrado.CPFiscal,
                            provincia: clienteEncontrado.ProvinciaFiscal,
                            comentarios: '',
                            codigoCliente: clienteEncontrado.Codigo,
                            pais: this.getNombrePais(
                              clienteEncontrado.PaisFiscal
                            ),
                          };
                          return this.facturaService.crearFacturaSimplificada(
                            cliente,
                            1,
                            true
                          );
                        } else {
                          return of(null);
                        }
                      } else {

                        const clienteIdInternet = this.configuration.internetConfig?.DatosResult?.ClienteId;
                        //const clienteIdSeleccionado = this.ventaService.clienteSeleccionadoValue.Codigo;
                            
                        if (mantenerClienteSeleccionado === clienteIdInternet) {
                            // Puede generar factura simplificada
                            // es un cliente internet, el mismo tiene que permitir esta factura

                            cliente = {
                              codigoCliente: mantenerClienteSeleccionado,
                            };
                            return this.facturaService.crearFacturaSimplificada(cliente, 1, true);
                        }

                        //return this.facturaService.crearFacturaSimplificada(cliente, 1, true);
                        return of(null);
                      }
                    })
                  )
                  .subscribe(
                    (res) => {
                      if (res && res.DatosResult) {
                        if (
                          (!this.pagoService.noMailValue &&
                            this.pagoService.sendMailValue) ||
                          !this.pagoService.sendMailValue
                        ) {
                          this.facturaService
                            .impresionFactura(res.DatosResult, this.mails)
                            .subscribe(
                              (response) => {
                                this.albaranService
                                  .refrescarAlbaran(
                                    this.albaranService.albaranValue.NumAlbaran
                                  )
                                  .subscribe();
                              },
                              (error) => {
                                this.mostrarError(error, true);
                                this.albaranService
                                  .refrescarAlbaran(
                                    this.albaranService.albaranValue.NumAlbaran
                                  )
                                  .subscribe();
                              }
                            );
                        } else {
                        }
                      }
                    },
                    (error) => {

                    }
                  );
              }
            } else {
              this.facturaService
                .crearFacturaSimplificada(cliente, 1)
                .pipe(first())
                .subscribe(
                  (res) => {
                    if (res && res.DatosResult) {
                      if (
                        (!this.pagoService.noMailValue &&
                          this.pagoService.sendMailValue) ||
                        !this.pagoService.sendMailValue
                      ) {
                        this.facturaService
                          .impresionFactura(res.DatosResult, this.mails)
                          .subscribe(
                            (response) => {
                              this.albaranService
                                .refrescarAlbaran(
                                  this.albaranService.albaranValue.NumAlbaran
                                )
                                .subscribe();
                            },
                            (error) => {
                              this.albaranService
                                .refrescarAlbaran(
                                  this.albaranService.albaranValue.NumAlbaran
                                )
                                .subscribe();
                            }
                          );
                      } else {

                      }
                    }
                  },
                  (error) => {

                    this.mostrarError(error);
                  }
                );
            }
          }
          
          // Llamar siempre a GenerarFactura si no se seleccionó factura ni factura simple
          // Esto cumple con la Ley Antifraude: el API decide si la facturación es obligatoria
          if (!this.pagoService.hayQueFacturarValue && !this.pagoService.hayQueFacturarSimpleValue) {
            this.facturaService
              .crearFacturaObligatoria()
              .pipe(first())
              .subscribe(
                (resFactura) => {
                  // Si la respuesta tiene FraNumero y FraSerie, generar PDF
                  if (resFactura && resFactura.DatosResult && 
                      resFactura.DatosResult.FraNumero && 
                      resFactura.DatosResult.FraSerie) {
                    if (
                      (!this.pagoService.noMailValue &&
                        this.pagoService.sendMailValue) ||
                      !this.pagoService.sendMailValue
                    ) {
                      this.facturaService
                        .impresionFactura(resFactura.DatosResult, this.mails)
                        .subscribe(
                          (response) => {
                            this.albaranService
                              .refrescarAlbaran(
                                this.albaranService.albaranValue.NumAlbaran
                              )
                              .subscribe();
                          },
                          (error) => {
                            // Error silencioso - no mostrar mensaje al usuario
                            this.albaranService
                              .refrescarAlbaran(
                                this.albaranService.albaranValue.NumAlbaran
                              )
                              .subscribe();
                          }
                        );
                    }
                  }
                  // Si no hay FraNumero/FraSerie, no hacer nada (el API decidió que no es obligatorio)
                },
                (error) => {
                  // Error silencioso - no mostrar mensaje al usuario si falla la factura obligatoria
                }
              );
          }

          if (this.pagoService.hayContactosValue === true) {
            this.modalService.open('datoscontacto');
          }
          if (
            this.ventaService.carritoValue.entradas.filter(
              (e) => e.entrada.noEditable
            ).length !== 0
          ) {
            this.modalService.open('confirmarEntradasLocalizador');
          }
          if (this.pagoService.hayQueImprimirAlbaranValue) {
            this.cabeceraSub = this.pagoService.datosCabecera().subscribe(
              (data) => {
                // if (this.ventaService.carritoValue.precioPrepago) {
                //   this.printService.printPurchaseAlbaran(
                //     res,
                //     data
                //   );
                // } else {
                //   this.printService.printPurchaseAlbaran(res, data);
                // }
                //Yaribel 20210202 añadimos impresion de justicante de saldo
                if (res.datos.AlbaranFOPs.find((x) => x.FOP == 'TM')) {
                  const codigo = res.datos.AlbaranFOPs.find(
                    (x) => x.FOP == 'TM'
                  ).TarjetaMonederoCodigo;
                  let saldo = 0;
                  this.validarTarjetaMonederoSub = this.pagoService
                    .validarTarjetaMonedero(codigo)
                    .subscribe((respuesta) => {
                      if (respuesta !== undefined && respuesta.DatosResult) {
                        saldo = respuesta.DatosResult.SaldoDisponible;
                        this.printService.imprimirSaldoMonedero(codigo, saldo);
                      }
                      this.validarTarjetaMonederoSub.unsubscribe();
                    });
                }
              },
              (error) => {
                this.disabledEntrar = false;
                this.imprimiendoTickets = false;
                // Toma acciones adicionales como mostrar un mensaje de error al usuario
                console.error('Error al imprimir el QR:', error);
              }
            );

            if (
              this.carritoOrigen &&
              this.carritoOrigen.reservaPagada &&
              this.carritoOrigen.reservaPagada == '1'
            ) {
              // this.reImprimirTicketsSub = this.localizadorService
              // .reimprimirTickets(this.localizadorService.localizadorValue.ClaveReserva)
              // .subscribe((infoImpresion) => {
              //   //<<Yaribel 20210126 unificamos la impresion de tickets en uno solo
              //   // this.printService.imprimirTicketUnico(
              //   //   this.configuration.datosTPVPathValue.Nombre,
              //   //   this.configuration.datosTPVPathValue.pkId,
              //   //   '',
              //   //   infoImpresion,
              //   //   this.localizadorService.localizadorValue.FechaHoraEntrada.split(' ')[1],
              //   //   this.localizadorService.localizadorValue.ReservaItems,
              //   //   this.localizadorService.localizadorValue.ClaveReserva,
              //   //   moment(this.localizadorService.localizadorValue.ReservaHistorial[0].Fecha).format('DD/MM/YYYY'),
              //   //   this.localizadorService.localizadorValue.ReservaHistorial[0].Hora.slice(0, -3),
              //   //   this.localizadorService.localizadorValue.ReservaRecintos,
              //   //   this.localizadorService.localizadorValue.ReservaMotivos,
              //   //   this.localizadorService.localizadorValue.Localizador,
              //   //   "0" //this.albaran.TipoImpresion
              //   // );
              //   // Yaribel 20210126 >>
              //   if(this.reImprimirTicketsSub) {this.reImprimirTicketsSub.unsubscribe();}
              // });
            }
          }
          if (this.pagoService.opcionesPagoValue.controls['tickets'].value) {
            const entradasDeVenta =
              this.ventaService.carritoValue.entradas.filter(
                (e) => !e.entrada.noEditable // TODO Yaribel 20210120 consultar porque se gestiona asi,  no existe noEditable en el objeto
              );

            //<<Yaribel 20210126 unificamos la impresion de tickets en uno solo
            // this.printService.imprimirTicketUnico(
            //       this.configuration.datosTPVPathValue.Nombre,
            //       this.configuration.datosTPVPathValue.pkId,
            //       res.NumAlbaran,
            //       res.infoImpresion,
            //       res.datos.FechaHoraEntrada.split(' ')[1],
            //       res.datos.AlbaranItems, //entradasDeVenta,   // TODO consultar porque se gestiona asi Yaribel 20210120 Modificamos entradasDeVenta por el items para recibir entradas e imprimir precio
            //       res.Identificador,
            //       moment(res.datos.AlbaranHistorial[0].Fecha).format(
            //         'DD/MM/YYYY'
            //       ),
            //       res.datos.AlbaranHistorial[0].Hora.slice(0, -3),
            //       res.datos.AlbaranRecintos,
            //       res.datos.AlbaranMotivos,
            //       res.datos.Localizador.length > 0? res.datos.Localizador : res.datos.NumVenta,
            //       res.datos.TipoImpresion
            //     );
            // Yaribel 20210126 >>
            if (
              this.ventaService.carritoValue.entradas.filter(
                (e) => e.entrada.noEditable
              ).length !== 0
            ) {
              this.modalService.open('confirmarEntradasLocalizador');
            }
          }
          if (this.pagoService.HayQueImprimirEtiquetasValue) {
            // this.modalService.open('etiquetas');
          }
          this.disabledEntrar = false;
          this.ventaService.carritoModificado = false;
          this.ventaService.setHayDescuento(false); //Yaribel 20210730  cliente Mapfre VSTS 8370
          this.stepperNavigation.desbloquearNavegacionPorPago();
          this.pagoService.setPagoTotal(undefined);
          this.pagoService.setCambio(undefined);
          this.pagoService.setDiferencia(undefined);
          this.pagoService.resetPagoDesglosado();
          this.ventaService.setFechaSeleccionadaValue(moment());
          this.ventaService.setClienteSeleccionadoValue('');
          this.ventaService.currentCliente = '0';
          this.ventaService.actualizarCantidadVentas(res.cambioDevuelto);
          this.ventaService.currentRecinto = undefined;
          this.stepperNavigation.resetearPasos();
          this.carrito.resetearCarrito();
          this.ventaService.setCarritoOrigen(new Carrito());
          this.butacaService.removeAllButaca();
          this.motivosService.setMotivosSeleccionados([]);
          this.sidebarNavigation.unblockSecciones();
          this.stepperNavigation.continuarVenta.next(false);
          this.procedenciaService.setProcedenciasValue(undefined);
          this.sinpeService.emitirTotalPagar('0', []);
          if (this.pagoService.hayQueFacturarValue === false) {
            this.pagoService.setStringMailValue('');
          }

          if (this.configuracion.getConfig('COMPRAINICIO')) {
            this.router.navigate([
              this.configuracion.getConfig('COMPRAINICIO'),
            ]);
          } else {
            this.router.navigate(['']);
          }
        } else {
          if (res.Mensajes[0].DescripcionMensaje.includes('Servicio Técnico')) {
            this.toast.info(
              'Ha sido imposible conectarse a la Escuela. Por favor, avise al Servicio Técnico',
              'Info',
              {
                toastComponent: InfoToast,
                timeOut: 7500,
              }
            );
          } else if (
            res.Mensajes[0].DescripcionMensaje.includes(
              'No hay aforo para el horario:'
            )
          ) {
            let posicion = res.Mensajes[0].DescripcionMensaje.indexOf(
              'No hay aforo para el horario:'
            );
            this.toast.info(
              'No ha sido posible insertar en escuela. ' +
                res.Mensajes[0].DescripcionMensaje.substring(posicion),
              'Info',
              {
                toastComponent: InfoToast,
                timeOut: 7500,
              }
            );
          } else {
            this.disabledEntrar = false;
            this.toast.error(res.Mensajes[0].DescripcionMensaje, 'Error', {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });
          }
        }

        this.pagoService.setOtrasFopData([]);
        this.pagoService.setCVaccancePago({
          FOP: '',
          Importe: 0,
          CVaccance: [],
        });

        console.log('limpiar amigo activo factura service')
        // una vez que se realiza la venta, limpiamos de memoria
        // la informacion de amigos thyssen
        this.amigosThyssenService.clearAmigoActivo();

      })
      
  }

  getNombrePais(codigo) {
    let NombrePais = codigo;
    let pais: pais;
    if (codigo && codigo != '') {
      pais = this.listadoPaises.find((x) => x.CodPais === codigo);
      if (pais && pais.NombrePais) NombrePais = pais.NombrePais;
    } else {
      NombrePais = '';
    }
    return NombrePais;
  }

  mostrarError(error: any, isErrorPrint = false) {
    if ([204, 400, 401, 404, 500].includes(error.status)) {
      const message = isErrorPrint
        ? 'ERROR_GENERAR_FACTURA_AVISAR_ENCARGADO'
        : 'ERROR_AVISAR_ENCARGADO';

      this.toastr.error('Error', this.translateService.instant(message), {
        toastComponent: ErrorToast,
      });
    } else {
      this.toastr.error(
        'Error',
        this.translateService.instant('ERROR_DESCONOCIDO'),
        {
          toastComponent: ErrorToast,
        }
      );
    }
  }

  async llamarPeticionDePago() {
    // Si se cumple la condicion se debe anular el albaran
    try {
      if (
        this.ventaService.carritoValue.albaran &&
        this.ventaService.carritoValue.albaran.MediosPago &&
        this.ventaService.carritoValue.albaran.pkId &&
        this.ventaService.carritoValue.albaran.pkId != ''
      ) {
        //
        this.anularVenta();
      } else {
        await this.llamarPeticionDePago2();
      }
    } catch (error) {
      throw new Error(error);
    }

    //this.imprimiendoTickets = false;
  }

  /** Último valor devuelto para no loguear en cada change detection. */
  private _lastSePuedeFinalizarResult: boolean | null = null;
  /** Últimas comprobaciones en false (solo logueamos cuando cambian). */
  private _lastEnFalse: string = '';

  sePuedeFinalizar() {
    const gestorActivoPorApi =
      this.appConfigValue?.AppConfigJsonPago?.GestorEfectivo?.GestorActivo === '1';
    const gestorActivo =
      gestorActivoPorApi && this.gestorEfectivoService.isCashManagerConnected();

    // Apaño para precio 0
    if (
      this.ventaService.carritoValue.entradas.length > 0 &&
      this.ventaService.carritoValue.precioTotal == 0 &&
      !this.ventaService.carritoValue.carrito &&
      this.ventanaActualDePago
    ) {
      return this.logSiCambioFinalizar(false, gestorActivo, {
        apañoPrecio0: true,
      });
    }

    const diferenciaOk =
      this.pagoService.diferenciaValue === 0 ||
      this.ventaService.carritoValue.precioTotal === 0 ||
      gestorActivo;
    const formOk =
      this.pagoService.formularioCorrectoValue || gestorActivo;
    const noEstaPagando = !this.estaPagando;
    const comprobaciones: Record<string, boolean> = {
      diferenciaOk,
      formOk: !!formOk,
      ventanaActualDePago: this.ventanaActualDePago,
      noEstaPagando,
    };
    const disabled =
      !(diferenciaOk && this.ventanaActualDePago && formOk && noEstaPagando);
    return this.logSiCambioFinalizar(disabled, gestorActivo, comprobaciones);
  }

  /**
   * Devuelve el valor y, cuando estamos en pago, loguea si cambia el resultado o las comprobaciones en false.
   */
  private logSiCambioFinalizar(
    result: boolean,
    gestorActivo: boolean,
    comprobaciones: Record<string, boolean>
  ): boolean {
    const enFalse = Object.entries(comprobaciones)
      .filter(([, v]) => !v)
      .map(([k]) => k)
      .sort()
      .join(',');
    const resultadoCambio = this._lastSePuedeFinalizarResult !== result;
    const enFalseCambio = this._lastEnFalse !== enFalse;

    if (this.ventanaActualDePago) {
      if (result) {
        if (enFalseCambio) {
          this._lastEnFalse = enFalse;
        }
      } else {
        this._lastEnFalse = '';
      }

      if (gestorActivo && resultadoCambio) {
      }
      this._lastSePuedeFinalizarResult = result;
    } else {
      this._lastSePuedeFinalizarResult = null;
      this._lastEnFalse = '';
    }

    return result;
  }

  conversor(precio: string) {
    return Number.parseFloat(precio.replace(/,/, '.'));
  }

  getPriceByLinea(price: string, quantity: number) {
    const precio = this.conversor(price);
    if (isNaN(precio) || isNaN(quantity)) {
      return 0;
    }

    const precioFinal = precio * quantity;

    if (isNaN(precioFinal)) {
      return 0;
    }
    if (precioFinal < 0) {
      return 0;
    }

    return precioFinal.toFixed(2);
  }

  getPrecioConComision(entrada: Entrada): number {
    const precio = parseFloat((entrada.PrecioEnDivisaReferencia || '0').replace(',', '.'));
    const comision = parseFloat((entrada.Comision || '0').replace(',', '.'));
    return precio + comision;
  }

  /** Total a pagar sumando (precio + comisión) por cada línea, coherente con getPrecioConComision. */
  getPrecioTotalConComision(): number {
    const carrito = this.ventaService.carritoValue;
    if (!carrito?.entradas?.length) return 0;
    return carrito.entradas.reduce(
      (sum, linea) => sum + this.getPrecioConComision(linea.entrada) * linea.cantidad,
      0
    );
  }

  getFechaSeleccionada() {
    if (
      this.ventaService.fechaSeleccionadaValue &&
      this.ventaService.fechaSeleccionadaValue !== ''
    ) {
      return moment(this.ventaService.fechaSeleccionadaValue)
        .locale(this.idioma)
        .format('L');
    }

    return '';
  }

  getFecha() {
    const fechaHoy = moment();
    if (
      !this.ventaService.fechaSeleccionadaValue ||
      this.ventaService.fechaSeleccionadaValue === ''
    ) {
      this.paseHorarioSeleccion = '';
      return this.translateService.instant('VentaSinFecha');
    }
    if (fechaHoy.isSame(this.ventaService.fechaSeleccionadaValue, 'day')) {
      if (
        this.ventaService.carritoValue.horarios.filter((x) => x.resumen !== '')
          .length == 0
      )
        return (this.paseHorarioSeleccion = this.translateService.instant(
          'SIN_SELECCION_PASE_HORARIO'
        ));
    }
    return moment(this.ventaService.fechaSeleccionadaValue)
      .locale(this.idioma)
      .format('dddd D, MMMM YYYY');
  }

  getNombreCliente() {
    if (
      this.ventaService.clienteSeleccionadoValue &&
      this.ventaService.clienteSeleccionadoValue.NombreCliente
    ) {
      return `${this.ventaService.clienteSeleccionadoValue.NombreCliente}`;
    }
    return '';
  }

  getLocalizador() {
    const localizador = this.ventaService.carritoValue.localizador;
    if (!localizador) {
      return '';
    }

    // Si es un string, devolverlo directamente
    if (typeof localizador === 'string') {
      return localizador;
    }

    // Si es un objeto, devolver ClaveReserva si existe
    if (typeof localizador === 'object' && localizador.ClaveReserva) {
      return localizador.ClaveReserva;
    }

    return '';
  }

  getDescuentoFromCliente(cliente) {
    if (cliente.ConDescuento === 'True') {
      let tipoDto = '';
      switch (cliente.TipoDto) {
        case 'DT':
          tipoDto = ` %`;
          break;
        case 'PR':
          tipoDto = `,00 €`;
          break;
        default:
          break;
      }
      return `- ${this.ventaService.clienteSeleccionadoValue.Dto}${tipoDto}`;
    }
    return ``;
  }

  mostrarFinalizarPagar() {
    return 'PAGAR';
  }

  inputDeTeclado(event: KeyboardEvent, entrada: Entrada) {
    event.preventDefault();
    const key = event.key;

    this.numpadService.selected = event.target;
    this.numpadService.entrada = entrada;
    this.formControlService.setCurrentFormGroup(
      null,
      event.target,
      (event.target as HTMLElement).getAttribute('category')
    );

    if (this.isDeleteButtonPressed(key)) {
      this.formControlService.deleteChar();
      return;
    }

    if (this.isEnterButton(key)) {
      this.formControlService.unfocus();
      (event.target as HTMLElement).blur();
      return;
    }

    if (this.isNumberKey(key)) {
      this.formControlService.inputChar(key);
      return;
    }
  }

  isNumberKey(key: string): boolean {
    return /^[0-9]$/.test(key); // Acepta '0' a '9' desde cualquier fuente
  }

  isDeleteButtonPressed(key: string): boolean {
    return key === 'Backspace';
  }

  isEnterButton(key: string): boolean {
    return key === 'Enter';
  }

  checkIfModalOpen() {
    return this.modalService.exists('selector-mas-entradas')
      ? this.modalService.isOpen('selector-mas-entradas')
      : false;
  }

  closeModal() {
    if (
      this.modalService.exists('selector-mas-entradas') &&
      this.modalService.isOpen('selector-mas-entradas')
    ) {
      this.modalService.close('selector-mas-entradas');
    }
  }

  getFechaHora(entrada) {
    const fecha = moment(
      entrada.FechaHoraEntrada,
      'YYYY/MM/DD HH:mm:ss'
    ).format('L');
    const hora = moment(entrada.FechaHoraEntrada, 'YYYY/MM/DD HH:mm:ss').format(
      'HH:mm'
    );
    return fecha + ' - ' + hora;
  }

  pad(s, size) {
    while (s.length < (size || 2)) {
      s = '0' + s;
    }
    return s;
  }
  mapeaListaentradas2ListaProductos(listaentradas, filtroProducto?): string[] {
    let respuesta: string[] = [];
    listaentradas.forEach((element) => {
      let idProducto = '';
      if (element.entrada.TipoProducto == '2') {
        if (
          !filtroProducto ||
          filtroProducto == element.entrada.TipoPromocionId
        )
          idProducto =
            '2,' +
            element.entrada.TipoPromocionId +
            ',' +
            element.cantidad.toString();
      } else if (element.entrada.TipoProducto == '3') {
        if (!filtroProducto || filtroProducto == element.entrada.TipoAbonadoId)
          idProducto =
            '3,' +
            element.entrada.TipoAbonadoId +
            ',' +
            element.cantidad.toString();
      } else {
        if (!filtroProducto || filtroProducto == element.entrada.TipoEntradaId)
          idProducto =
            '1,' +
            element.entrada.TipoEntradaId +
            ',' +
            element.cantidad.toString();
      }
      respuesta.push(idProducto);
    });
    //if (respuesta.length > 0) respuesta = respuesta.slice(0, -1);
    return respuesta;
  }

  fechaYYYYMMDD2slash(fecha, hora) {
    let respuesta = '';
    if (fecha && fecha.length == 8) {
      respuesta =
        fecha.substring(0, 4) +
        '/' +
        fecha.substring(4, 6) +
        '/' +
        fecha.substring(6);
    }
    if (hora && hora.length == 5) {
      respuesta = respuesta + ' ' + hora + ':00';
    } else if (hora && hora.length == 8) {
      respuesta = respuesta + ' ' + hora;
    } else {
      respuesta = respuesta + ' ' + '23:59:00';
    }
    return respuesta;
  }

  imprimirJustificanteDevolucion(NumAlbaran: string, tipo: string) {
    //TODO  Yaribel 20201124 mejorar mapear el objeto y no usar refrescarAlbaran
    this.albaranService
      .refrescarAlbaran(NumAlbaran)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          const albaranValue = this.albaranService.albaranValue;
          const NombreTPV = this.albaranService.albaranValue.NombreTPV;
          const IdTPV = this.albaranService.albaranValue.IdTPV;
          this.pagoService
            .datosCabecera()
            .pipe(take(1))
            .subscribe((data) => {
              switch (tipo) {
                case 'TOTAL':
                  this.printService.printRefundAlbaran(
                    {
                      datos: albaranValue,
                      NombreTPV: NombreTPV,
                      IdTPV: IdTPV,
                    },
                    data
                  );
                  break;
                case 'PARCIAL':
                  this.printService.printPartialRefund(
                    {
                      datos: albaranValue,
                    },
                    data
                  );
                  break;
              }
            });
        }
      });
  }

  agruparCaracteristicas(CaracteristicasEntrada) {
    const nuevo = [];
    CaracteristicasEntrada.forEach((caracteristica) => {
      if (
        !nuevo.find(
          (cat) =>
            cat.Tipo === caracteristica.Tipo &&
            cat.Rango === caracteristica.Rango &&
            cat.Nivel === caracteristica.Nivel
        )
      ) {
        nuevo.push(caracteristica);
      }
    });
    return nuevo;
  }

  verCarrito() {
    const reservaAgrupadaActiva =
      (!this.carrito?.reservaPagada || this.carrito.reservaPagada == '0') &&
      this.carrito?.reservaAgrupada == '1';
    if (reservaAgrupadaActiva) {
      return this.carrito.entradas;
    }
    // Venta normal: el resumen debe leer el mismo carrito que muta «X» (carrito activo). El origen solo si aún no hay líneas en el carrito.
    return this.carrito?.entradas?.length
      ? this.carrito.entradas
      : this.carritoOrigen?.entradas || [];
  }

  disableButtonEnter() {
    return this.disabledEntrar;
  }

  cargarAlbaran() {
    this.albaranService.getUltimoAlbaran(this.turnoService.turnoValue.TpvId);
  }

  disabledSalePause() {
    // Apaño para precio 0
    if (
      this.ventaService.carritoValue.entradas.length === 0 &&
      this.ventaService.carritoValue.precioTotal === 0 &&
      !this.ventaService.carritoValue.carrito
    ) {
      return true;
    }

    return false;
  }

  showSalePauseButton() {
    const jsonConfig = this.appConfigValue;

    if (!jsonConfig || !jsonConfig.AppConfigJsonConfig) {
      return false;
    }

    const pausarVentas = jsonConfig.AppConfigJsonConfig.PausarVentas;
    return +pausarVentas === 1;
  }
}
